<script setup>
import { ref, onMounted, computed, getCurrentInstance } from "vue";
import { Icon } from '@iconify/vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm, usePage } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiHomeSearch, mdiWhatsapp, mdiCashPlus,
    mdiCradle, mdiPuzzleRemove, mdiTownHall, mdiCross, mdiPill, mdiMedicalBag, mdiGymnastics, mdiWater, mdiCheckDecagram, mdiContentSave, mdiAccountSupervisor,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail, mdiInformationOutline, mdiPrinter, mdiFileDocumentMultipleOutline,
    mdiCardAccountDetails, mdiGenderMaleFemale, mdiCellphone, mdiEmail, mdiClockTimeFive,
    mdiSchool
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import TableResponsive from "@/Components/TableResponsive.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import CompetencyGraphic from "@/Components/CompetencyGraphic.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    //apoderado: Object,
    typeDocuments: Object,
    distritos: Object,
    colegios: Object,
    parentescos: Object,
    religions: Object,
    estadoCiviles: Object,
    cursosNow: Object,
    chartCompetencias: Object,
    levels: Object,
    classrooms: Object,
    teoricClassrooms: Object,
    levelsvacacional: Object,
    classroomsvacacional: Object,
    events: Array,
    user: Object,
    user_modif: Object,
    user_modif_status: Object,
    isAdmin: Boolean,
    isAdminCoord: Boolean,
    isCoord: Boolean,
    isTutor: Boolean,
    isPsico: Boolean,
    isSecre: Boolean,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    anioEscolar: String,
    back_link: String,
    closeB1: Boolean,
    closeB2: Boolean,
    closeB3: Boolean,
    closeB4: Boolean,
    existParcial2B1: Boolean,
    existParcial2B2: Boolean,
    existParcial2B3: Boolean,
    existParcial2B4: Boolean,
    debugInertia: Boolean,
    stories: Array,
    apoderados: Array,
    sedes: Object,
    levelSuffix: String
});


/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const page = usePage();
const confGlobal = computed(() => {
    const raw = page.props.value?.confGlobal || {};
    return new Proxy(raw, {
        get(target, prop, receiver) {
            if (prop === 'value') {
                return receiver;
            }
            return Reflect.get(target, prop, receiver);
        },
        has(target, prop) {
            if (prop === 'value') {
                return true;
            }
            return Reflect.has(target, prop);
        }
    });
});

const studentLevelSuffix = computed(() => {
    if (props.levelSuffix) return props.levelSuffix;
    if (props.object && props.levels && props.object.id_level) {
        const lvl = Array.isArray(props.levels)
            ? props.levels.find(l => l.id == props.object.id_level)
            : Object.values(props.levels).find(l => l.id == props.object.id_level);
        if (lvl) {
            const parentRef = lvl.parent_ref || lvl.ref_parent || '';
            if (parentRef === 'INI') return 'INICIAL';
            if (parentRef === 'SEC') return 'SECUNDARIA';
            if (parentRef === 'PRIM') return 'PRIMARIA';
        }
    }
    return 'PRIMARIA';
});

const defaultCriteria = ['examen_parcial', 'examen_parcial2', 'examen_final'];

const publishedCriteriaForStudent = computed(() => {
    const constName = 'CALIFICATION_PUBLISH_CRITERIA_' + studentLevelSuffix.value;
    const raw = confGlobal.value ? confGlobal.value[constName] : null;
    if (!raw || raw === '0' || raw === '') {
        const legacy = confGlobal.value?.CALIFICATION_PUBLISH_CRITERIA;
        if (legacy === 'todos') {
            return ['criterio1', 'criterio2', 'criterio3', 'criterio4', 'criterio5', 'criterio6', 'examen_parcial', 'examen_parcial2', 'examen_final'];
        }
        return [...defaultCriteria];
    }
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
    } catch (e) {
        if (typeof raw === 'string' && raw.includes(',')) {
            return raw.split(',').map(s => s.trim());
        }
    }
    return [...defaultCriteria];
});

const isCriteriaPublished = (criteriaKey) => {
    if (props.canWrite) return true;
    return publishedCriteriaForStudent.value.includes(criteriaKey);
};

const isBimestrePublished = (bimId) => {
    if (props.canWrite) return true;
    const constName = `CALIFICATION_PUBLISH_${bimId}_${studentLevelSuffix.value}`;
    return confGlobal.value && String(confGlobal.value[constName]) === '1';
};

const anioSearch = ref(null)
onMounted(() => {
    if (props.object) {
        listarChartCalification()
        listarPayes()
    }
    langs()
    //listarDocumentos()
    //listarAdmisionPuntaje()
});

const chartCalifications = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
const chartSelectCiclo = ref(null);
const listarChartCalification = (ref_ciclo = '') => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let id_student = props.object ? props.object.id : 0
    let url = '/calification/grafica' + '?id=' + id_student + '&ref_ciclo=' + ref_ciclo;
    if (ref_ciclo) {
        chartCalifications.value = null // <-- Limpiar value si se vuelve a consultar y no dejarlo en array
    }
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartCalifications.value = respuesta.datachart;// El return directo del array trae otros datos que generan error para el chart
        chartSelectCiclo.value = respuesta.refciclo
        console.log(respuesta);
    }).catch(function (error) {
        console.log(error);
    });
}

const pruebaevents = [
    { id: 1, start: '2023-04-19 12:00', end: '2023-04-19 13:00', title: 'Más trabajo, está bien 1', content: 'es mejor que halla más trabajo 1', deletable: 1 },
    { id: 2, start: '2023-04-20 12:00', end: '2023-04-23 17:00', title: 'Más trabajo, está bien 2', content: 'es mejor que halla más trabajo 2', split: 1 },
    { id: 3, start: '2023-04-20 12:00', end: '2023-04-21 14:00', title: 'Más trabajo, está bien 3', content: 'es mejor que halla más trabajo 3', allday: 1 },
    { id: 4, start: '2023-04-17 12:00', end: '2023-04-18 13:00', title: 'Más trabajo, está bien 4', content: 'es mejor que halla más trabajo 4', resizable: 1 }
]

const pruebanotas = {
    "files": [
        { "id": 1, "course": "Geometría", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('student')
const modulo = ref('Estudiante')
const modulos = ref('Estudiantes')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)
if (action.value == 'view_apoderado') {
    tab.value = 1
}

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Persona
    apellidos: props.object ? props.object.person.apellidos : '',
    nombres: props.object ? props.object.person.nombres : '',
    id_type_document: props.object ? props.object.person.id_type_document : 1,// 1 DNI
    num_doc: props.object ? props.object.person.num_doc : '',
    domicilio: props.object ? props.object.person.domicilio : '',
    sexo: props.object ? props.object.person.sexo : 0,
    id_distrito_domicilio: props.object ? (props.object.person.id_distrito_domicilio ?? null) : null,// Sedeje documento que es posible hacer esto
    referencia: props.object ? props.object.person.referencia : '',
    fecha_nacimiento: props.object ? props.object.person.fecha_nacimiento : '',
    id_distrito_nacimiento: props.object ? props.object.person.id_distrito_nacimiento : null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: props.object ? props.object.person.telefono : '',
    celular: props.object ? props.object.person.celular : '',
    email: props.object ? props.object.person.email : '',

    // Estudiante
    id_colegio_procedencia: props.object ? props.object.id_colegio_procedencia : null,
    id_distrito_colegio: props.object ? props.object.id_distrito_colegio : null,
    id_religion: props.object ? props.object.id_religion : null,
    exonerado_religion: props.object ? props.object.exonerado_religion : 0,
    alergia: props.object ? props.object.alergia : '',
    enfermedad: props.object ? props.object.enfermedad : '',
    apto_edu_fisica: props.object ? props.object.apto_edu_fisica : 1,// Si está apto por defecto
    tamisaje_hemoglobina: props.object ? props.object.tamisaje_hemoglobina : 0,
    obs_aprendizaje: props.object ? props.object.obs_aprendizaje : '',
    obs_seguro_salud: props.object ? props.object.obs_seguro_salud : '',
    obs_situacion_familiar: props.object ? props.object.obs_situacion_familiar : '',
    obs_datos_vivienda: props.object ? props.object.obs_datos_vivienda : '',
    id_estado_civil_padres: props.object ? props.object.id_estado_civil_padres : null,
    obs_estado_padres: props.object ? props.object.obs_estado_padres : '',
    fecha_matricula: props.object ? props.object.fecha_matricula : '',
    type: props.object ? props.object.type : 0,// Antigui
    //status_financiero: props.object ? props.object.status_financiero : 0
    vacuna_pentavalente: props.object ? props.object.vacuna_pentavalente : 0,
    vacuna_odpt: props.object ? props.object.vacuna_odpt : 0,
    obs_otros: props.object ? props.object.obs_otros : '',
    aprendizaje_terapia: props.object ? props.object.aprendizaje_terapia : 0,
    id_level: props.object ? props.object.id_level : null,
    id_classroom: props.object ? props.object.id_classroom : null,
    id_classroom_ugel: props.object ? props.object.id_classroom_ugel : null,
    id_classroom_matricula: props.object ? props.object.id_classroom_matricula : null,
    pension_preferencial: props.object ? props.object.pension_preferencial : 0,
    becado: props.object ? props.object.becado : 0,
    note: props.object ? props.object.note : '',
    financial_note: props.object ? props.object.financial_note : '',
    ref_ugel: props.object ? props.object.ref_ugel : '',
    fecha_retiro: props.object ? props.object.fecha_retiro : '',
    fecha_reingreso: props.object ? props.object.fecha_reingreso : '',
    fecha_compromiso_pago: props.object ? props.object.fecha_compromiso_pago : '',
    sede_origen: props.object ? props.object.sede_origen : '',
    change_login: 0,
    status: props.object ? props.object.status : 2, // Ingresante regular

    // Crear ordne de pago
    crear_orden_pago: 0,
    orderAnio: props.anioEscolar,
    order03: false,
    order04: false,
    order05: false,
    order06: false,
    order07: false,
    order08: false,
    order09: false,
    order10: false,
    order11: false,
    order12: false,
    order13: false,

    // Vacacional
    fecha_matricula_vacacional: props.object ? props.object.fecha_matricula_vacacional : '',
    id_level_vacacional: props.object ? props.object.id_level_vacacional : null,
    id_classroom_vacacional: props.object ? props.object.id_classroom_vacacional : null,

    // Contacto al crear estudiante
    contact_id_person: 0,
    contact_apellidos: '',
    contact_nombres: '',
    contact_id_type_document: 1,// 1 DNI
    contact_num_doc: '',
    contact_sexo: 0,
    contact_fecha_nacimiento: '',
    contact_celular: '',
    contact_email: '',
    contact_id_parentesco: null,
    contact_type: null
});

const formApoderado = useForm({
    id_student: props.object ? props.object.id : 0,
    id: 0,
    // Persona
    id_person: 0,
    apellidos: '',
    nombres: '',
    id_type_document: 1,// 1 DNI
    num_doc: '',
    domicilio: '',
    sexo: 0,
    id_distrito_domicilio: null,// Sedeje documento que es posible hacer esto
    referencia: '',
    fecha_nacimiento: '',
    id_distrito_nacimiento: null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: '',
    celular: '',
    email: '',

    // Contact
    id_parentesco: null,
    ocupation: null,
    trabajo: null,
    horario_laboral: '',
    telefono_trabajo: '',
    celular_trabajo: '',
    note: null,
    type: null,
    change_login_apoderado: 0
});

const typeContacts = ref([{ 'id': 0, 'label': 'Otro' }, { 'id': 1, 'label': 'Responsable de pagos' }, { 'id': 2, 'label': 'Responsable de Facturación' }, { 'id': 3, 'label': 'Responsable de Pagos y Facturación' }])

//console.log(props.typeDocuments)

const apoderado = ref(null)

const actualizarContacto = (object = null) => {
    apoderado.value = object
    //console.log(object)
    formApoderado.id = apoderado.value.id
    formApoderado.apellidos = apoderado.value.person.apellidos
    formApoderado.nombres = apoderado.value.person.nombres,
        formApoderado.id_type_document = apoderado.value.person.id_type_document,// 1 DNI
        formApoderado.num_doc = apoderado.value.person.num_doc,
        formApoderado.domicilio = apoderado.value.person.domicilio,
        formApoderado.sexo = apoderado.value.person.sexo,
        formApoderado.id_distrito_domicilio = apoderado.value.person.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
        formApoderado.referencia = apoderado.value.person.referencia,
        formApoderado.fecha_nacimiento = apoderado.value.person.fecha_nacimiento,
        formApoderado.id_distrito_nacimiento = apoderado.value.person.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
        formApoderado.telefono = apoderado.value.person.telefono,
        formApoderado.celular = apoderado.value.person.celular,
        formApoderado.email = apoderado.value.person.email,

        // Contact
        formApoderado.id_parentesco = apoderado.value.id_parentesco,
        formApoderado.ocupation = apoderado.value.ocupation,
        formApoderado.trabajo = apoderado.value.trabajo,
        formApoderado.horario_laboral = apoderado.value.horario_laboral,
        formApoderado.telefono_trabajo = apoderado.value.telefono_trabajo,
        formApoderado.celular_trabajo = apoderado.value.celular_trabajo,
        formApoderado.note = apoderado.value.note,// Si está apto por defecto
        formApoderado.type = apoderado.value.type ? apoderado.value.type : 0
    //formApoderado.change_login_apoderado
}

const getContactForDoc = (doc = '', createstudent = 0) => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let id_student = props.object ? props.object.id : 0
    let url = '/student/getContactForDoc' + '?documento=' + doc;
    axios.get(url).then((response) => {
        let respuesta = response.data;
        //apoderado.value = respuesta; Si es un apoderado de otro estudiante u es un maestro
        crearContactoAPartirdeOtro(respuesta.apoderado, respuesta.isotherperson, createstudent)
        console.log(respuesta);
    }).catch((error) => {
        console.log(error.response); // error.response.data
    });
}

const existeContacto = ref(false)

const crearContactoAPartirdeOtro = (object = null, isotherperson = 0, createstudent) => {
    apoderado.value = object
    //console.log(object)
    if (apoderado.value.id > 0) {
        existeContacto.value = true
        if (isotherperson > 0) {
            // Es otra persona y se toma sus datos
            if (createstudent) {
                form.contact_id_person = apoderado.value.id // <-- Es otra persona no un contacto con id_person
                form.contact_apellidos = apoderado.value.apellidos
                form.contact_nombres = apoderado.value.nombres,
                    form.contact_id_type_document = apoderado.value.id_type_document,// 1 DNI
                    form.contact_num_doc = apoderado.value.num_doc,
                    form.contact_sexo = apoderado.value.sexo,
                    form.contact_fecha_nacimiento = apoderado.value.fecha_nacimiento,
                    form.contact_celular = apoderado.value.celular,
                    form.contact_email = apoderado.value.email
            } else {
                formApoderado.id_person = apoderado.value.id
                formApoderado.apellidos = apoderado.value.apellidos
                formApoderado.nombres = apoderado.value.nombres,
                    formApoderado.id_type_document = apoderado.value.id_type_document,// 1 DNI
                    formApoderado.num_doc = apoderado.value.num_doc,
                    formApoderado.domicilio = apoderado.value.domicilio,
                    formApoderado.sexo = apoderado.value.sexo,
                    formApoderado.id_distrito_domicilio = apoderado.value.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
                    formApoderado.referencia = apoderado.value.referencia,
                    formApoderado.fecha_nacimiento = apoderado.value.fecha_nacimiento,
                    formApoderado.id_distrito_nacimiento = apoderado.value.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
                    formApoderado.telefono = apoderado.value.telefono,
                    formApoderado.celular = apoderado.value.celular,
                    formApoderado.email = apoderado.value.email
            }

            console.log('Contacto nuevo desde otra persona')
        } else {
            console.log(apoderado.value.id_person);

            if (createstudent) {
                form.contact_id_person = apoderado.value.id_person
                form.contact_apellidos = apoderado.value.person.apellidos
                form.contact_nombres = apoderado.value.person.nombres,
                    form.contact_id_type_document = apoderado.value.person.id_type_document,// 1 DNI
                    form.contact_num_doc = apoderado.value.person.num_doc,
                    form.contact_sexo = apoderado.value.person.sexo,
                    form.contact_fecha_nacimiento = apoderado.value.person.fecha_nacimiento,
                    form.contact_celular = apoderado.value.person.celular,
                    form.contact_email = apoderado.value.person.email,

                    // Contact
                    form.contact_id_parentesco = apoderado.value.id_parentesco,
                    form.contact_type = apoderado.value.type ? apoderado.value.type : 0
            } else {
                formApoderado.id_person = apoderado.value.id_person
                formApoderado.apellidos = apoderado.value.person.apellidos
                formApoderado.nombres = apoderado.value.person.nombres,
                    formApoderado.id_type_document = apoderado.value.person.id_type_document,// 1 DNI
                    formApoderado.num_doc = apoderado.value.person.num_doc,
                    formApoderado.domicilio = apoderado.value.person.domicilio,
                    formApoderado.sexo = apoderado.value.person.sexo,
                    formApoderado.id_distrito_domicilio = apoderado.value.person.id_distrito_domicilio,// Sedeje documento que es posible hacer esto
                    formApoderado.referencia = apoderado.value.person.referencia,
                    formApoderado.fecha_nacimiento = apoderado.value.person.fecha_nacimiento,
                    formApoderado.id_distrito_nacimiento = apoderado.value.person.id_distrito_nacimiento,// Pero se toma null par ambos casos de crear o editar que sea vacío
                    formApoderado.telefono = apoderado.value.person.telefono,
                    formApoderado.celular = apoderado.value.person.celular,
                    formApoderado.email = apoderado.value.person.email,

                    // Contact
                    formApoderado.id_parentesco = apoderado.value.id_parentesco,
                    formApoderado.ocupation = apoderado.value.ocupation,
                    formApoderado.trabajo = apoderado.value.trabajo,
                    formApoderado.horario_laboral = apoderado.value.horario_laboral,
                    formApoderado.telefono_trabajo = apoderado.value.telefono_trabajo,
                    formApoderado.celular_trabajo = apoderado.value.celular_trabajo,
                    formApoderado.note = apoderado.value.note,// Si está apto por defecto
                    formApoderado.type = apoderado.value.type ? apoderado.value.type : 0
                //formApoderado.change_login_apoderado
            }
            console.log('Contacto desde otro contacto')
        }
    } else {

        console.log('Contacto nuevo')
    }

}

const clean = (origen = '') => {
    if (origen == 'apoderado') {
        existeContacto.value = false
        apoderado.value = null
        action.value = 'view_apoderado'
    }
    if (origen == 'student') {
        action.value = 'view'
    }

}

/**
 * 
 * LRR 
 * Incializar valorres
 */

const optionsGenero = [
    { id: 0, label: 'Femenino' },
    { id: 1, label: 'Masculino' },
]
const optionsTamizaje = [
    { id: 0, label: 'Pendiente con compromiso' },
    { id: 1, label: 'Realizado y entregado' },
]
const optionsTipoIngreso = [
    { id: 2, label: 'Ingresante Regular' },
    { id: 3, label: 'Egresado (para registro)' },
    { id: 0, label: 'Retirado (para registro)' },
]
const optionsTipoIngresoVaca = [
    { id: 2, label: 'Ingresante Regular' },
    { id: 4, label: 'Ingresante Vacacional' },
    { id: 3, label: 'Egresado (para registro)' },
    { id: 0, label: 'Retirado (para registro)' },
]

/*
const optionsVivienda = [
    {id: 0, label: 'Casa propia'},
    {id: 1, label: 'Casa alquilada'},
    {id: 2, label: 'Casa de otros familiares'},
    {id: 3, label: 'Casa alquilada'},
    {id: 9, label: 'Otro :'},
]
*/

// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// LRR un simple array para usar sólo option del componente input

// Seguro de salud
const optionsSeguroSalud = [
    'Particular',
    'ESSALUD',
    'SIS',
    'No tiene',
]
const selectSeguroSalud = ref('')
const textSeguroSalud = ref('')
if (props.object && props.object.obs_datos_SeguroSalud) {
    let arraySeguroSalud = props.object.obs_datos_SeguroSalud.split(' : ')
    selectSeguroSalud.value = arraySeguroSalud[0]
    if (arraySeguroSalud[1]) textSeguroSalud.value = arraySeguroSalud[1]
} else {
    selectSeguroSalud.value = optionsSeguroSalud[3]// <-- Selección por defecto al crear
}

// Situación familiar
const optionsSituacionFamiliar = [
    'Sus 2 padres y hermanos',
    'Sólo con su mamá',
    'Sólo con su papá',
    'Con otros familiares',
]
const selectSituacionFamiliar = ref('')
const textSituacionFamiliar = ref('')
if (props.object && props.object.obs_situacion_familiar) {
    let arraySituacionFamiliar = props.object.obs_situacion_familiar.split(' : ')
    selectSituacionFamiliar.value = arraySituacionFamiliar[0]
    if (arraySituacionFamiliar[1]) textSituacionFamiliar.value = arraySituacionFamiliar[1]
}

// Vivienda
const optionsVivienda = [
    'Casa propia',
    'Casa alquilada',
    'Casa de otros familiares',
    'Casa alquilada',
    'Otro'
]

const selectVivienda = ref('')
const textVivienda = ref('')
if (props.object && props.object.obs_datos_vivienda) {
    let arrayVivienda = props.object.obs_datos_vivienda.split(' : ')
    selectVivienda.value = arrayVivienda[0]
    if (arrayVivienda[1]) textVivienda.value = arrayVivienda[1]
    /* if (arrayVivienda.length > 1) {
        selectVivienda.value = arrayVivienda[0]
        textVivienda.value = arrayVivienda[1]
    } else {
        let result = props.object.obs_datos_vivienda.replace(' : ', '')
        optionsVivienda.includes(result) ? selectVivienda.value = result : textVivienda.value = result
    } */
} else {
    selectSeguroSalud.value = optionsSeguroSalud[4]// <-- Selección por defecto al crear
}


// Crear o actualizar
const submit = () => {
    if (action.value == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
        });
    } else {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onFinish: () => {
                form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje, change_login')
                clean('student')
            },
            onError: () => window.Toast.error(errors.create)
        });
    }

};

const submitApoderado = () => {
    if (action.value == 'create_apoderado') {
        formApoderado.post(route('apoderado-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => {
                formApoderado.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'id_parentesco')
                clean('apoderado')
            },
            //onError: () => window.Toast.error(errors.create)
        });
    } else {
        formApoderado.put(route('apoderado-actualizar'), {
            onFinish: () => {
                formApoderado.reset('apellidos, nombres, email, telefono, celular, id_parentesco, change_login_apoderado')
                clean('apoderado')

            },
            onError: () => window.Toast.error(errors.edit)
        });
    }

};

const showNotas = ref([])

//const cancel = () => {
//if (rutaPrefijo.value=='student') {
//form.obs_aprendizaje = '';
//}
//}

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

//console.log(props.object)
const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}

// Dividir secciones con tabs
let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

/**
 * Section Calification
 */
const cursos = ref(props.cursosNow)
const tabCalif = ref(-1)
const showLog = ref(false);
const formCalification = useForm({
    id_student: props.object ? props.object.id : null,// <-- Al crear estudiante noe xiste object
    ref_ciclo: '',
    //id_course: 0,
    criterio1: null,
    criterio2: null,
    criterio3: null,
    criterio4: null,
    criterio5: null,
    criterio6: null,
    examen_parcial: '8',
    examen_parcial2: null,
    examen_final: '8',
    promedio: '8',
    //promedio_number: 0, creado en el controller
    status: 0

});



//const doubleCLickBlock = ref(0)
const iniciarCalification = (ref_ciclo) => {
    /* for (let i = 0; i < props.students; i++) {
        pagesList.push(i);
    } */
    //doubleCLickBlock.value = 1

    // Determinar si existe Parcial 2 y asignar 8
    let existParcial2 = null
    if (tabCalif.value == 0 && props.existParcial2B1) {
        existParcial2 = true
    } else if (tabCalif.value == 1 && props.existParcial2B2) {
        existParcial2 = true
    } else if (tabCalif.value == 2 && props.existParcial2B3) {
        existParcial2 = true
    } else if (tabCalif.value == 3 && props.existParcial2B4) {
        existParcial2 = true
    } else {
        existParcial2 = false
    }

    //console.log(existParcial2)

    const newArr = [];
    const arr = cursos.value
    arr.forEach((course) => {
        newArr.push({
            id_student: formCalification.id_student,
            id_course: course.id,
            criterio1: (trans.value?.criterio1 ? '8' : null),
            criterio2: (trans.value?.criterio2 ? '8' : null),
            criterio3: (trans.value?.criterio3 ? '8' : null),
            criterio4: (trans.value?.criterio4 ? '8' : null),
            criterio5: (trans.value?.criterio5 ? '8' : null),
            criterio6: (trans.value?.criterio6 ? '8' : null),
            examen_parcial: formCalification.examen_parcial,
            examen_parcial2: (existParcial2 ? '8' : null),
            examen_final: formCalification.examen_final,
            promedio: formCalification.promedio,
            status: 0
        });
    });
    let ruta = 'calification-registrar'
    if (newArr.length) {
        axios.post(route(ruta), {
            'origin': 'student',
            'ref_ciclo': ref_ciclo,
            'arrayData': newArr,

        }).then((response) => {
            let respuesta = response.data;
            listarCalification(ref_ciclo)
            if (respuesta.error) {
                showAlert(respuesta.message, 'danger', 16)
            } else {
                showAlert('Se inició las calificaciones del ' + ref_ciclo, 'success', 3)
            }
            //console.log('Registro actualizado');
            console.log(newArr)
            console.log(respuesta.message)
            //doubleCLickBlock.value = 0
        }).catch((error) => {
            console.log(error);
        });

    }
    //return newArr;
}

const feedbackLabel = ref('');
const feedbackDesc = ref('');
const feedbackShow = ref(false);
let countAction = 0
let countActionOk = 0
let guardarTodo = 0
const updateCalification = (id, action, data = []) => {
    let ruta = 'calification-' + action
    if (id > 0) {

        if (action == 'actualizar') {
            //countAction++
            //alertIndex.value = 
            axios.put(route(ruta), {
                'id': id,
                'criterio1': data['criterio1'],
                'criterio2': data['criterio2'],
                'criterio3': data['criterio3'],
                'criterio4': data['criterio4'],
                'criterio5': data['criterio5'],
                'criterio6': data['criterio6'],
                'examen_parcial': data['examen_parcial'],
                'examen_parcial2': data['examen_parcial2'],
                'examen_final': data['examen_final'],
                'promedio': data['promedio'],
                'promedio_text': data['promedio_text'],
                'criterio5_peso': data['criterio5_peso'],
                'criterio6_peso': data['criterio6_peso'],
                'examen_parcial_peso': data['examen_parcial_peso'],
                'examen_parcial2_peso': data['examen_parcial2_peso'],
                'examen_final_peso': data['examen_final_peso']
            }).then((response) => {
                countAction++
                countActionOk++

                if (!guardarTodo) {
                    showAlert(countAction + ' registro actualizado', 'success')
                    countAction = 0
                    countActionOk = 0
                } else {
                    if (countAction == 1) {
                        showAlert('Validando, espere por favor ...', 'warning', 3)
                    }

                    if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                        showAlert(countActionOk + ' registros actualizados', 'success', 3)
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }

                //console.log(countAction+' registro actualizado');
            }).catch((error) => {
                console.log(error);
                errors.value = 1
                countAction++

                showAlert(countAction + ' registro con error', 'danger', 10)
                if (!guardarTodo) {
                    countAction = 0
                } else {
                    if (arrayCalifications.value && arrayCalifications.value.length == countAction) {
                        countAction = 0
                        countActionOk = 0
                        guardarTodo = 0
                    }
                }
                //console.log(countAction+' registro con error');
            });

            /* Inertia.put(route(ruta, {
                'id' : id,
                'asistencia': data['asistencia'],
                'participacion': data['participacion'],
                'tarea': data['tarea'],
                'conducta': data['conducta'],
                'examen_parcial': data['examen_parcial'],
                'examen_parcial2': data['examen_parcial2'],
                'examen_final': data['examen_final'],
                'promedio': data['promedio'],
                onFinish: () => { 
                        put.completed = true
                        feedbackLabel.value = 'User sucessfully Added!';
                        feedbackDesc.value = usePage().props.value.flash.notification;
                        feedbackShow.value = true;
                        console.log('Actualizado')
                    }
                }
            )) */
        } else {
            axios.put(route(ruta), {
                'id': id,
            }).then(function (response) {
                showAlert('Estado actualizado', 'success')

                // Lista dependiendo en que tab está
                if (tabCalif.value == 0) {
                    console.log('Primer bimestre')
                    listarCalification(props.anioEscolar + 'B1')
                } else if (tabCalif.value == 1) {
                    console.log('Segundo bimestre')
                    listarCalification(props.anioEscolar + 'B2')
                } else if (tabCalif.value == 2) {
                    console.log('Tercer bimestre')
                    listarCalification(props.anioEscolar + 'B3')
                } else if (tabCalif.value == 3) {
                    console.log('Cuarto bimestre')
                    listarCalification(props.anioEscolar + 'B4')
                }

                console.log('Año escolar: ' + props.anioEscolar);
            }).catch(function (error) {
                console.log(error);
            });
            //listarCalification()
            //Inertia.reload({ only: ['message']})
            console.log('Año escolar: ' + props.anioEscolar);
        }

    }

    //isAlertActive.value = true

    //console.log(arrayDiario.value)
}
const arrayCalifications = ref([])
const listarCalification = (ref_ciclo) => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/calification/student' + '?ref_ciclo=' + ref_ciclo + '&id_student=' + props.object.id + '&anioSearch=' + anioSearch.value; // <-- si no es el año lectivo actual tomar otra aula en el controller
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayCalifications.value = respuesta.datalist;
        if (respuesta.error) {
            showAlert(respuesta.message, 'danger', 16)
        }
        //console.log(arrayCalifications.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const number2nota = (notaN) => {
    let nota = parseFloat(notaN).toFixed(2);
    let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
    //console.log(nota)
    return result
}

/**
 * Proceso de consulta si es otro año
 */
const changeAnioConsulta = () => {
    listarCursos()
    listarAdmisionPuntaje()
}

const listarCursos = () => {
    let url = '/student/cursos?id_student=' + props.object.id + '&anioSearch=' + anioSearch.value;
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        cursos.value = respuesta.data;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    });
}

//const isActionMassive = ref(false)
const updateArrayCalifications = (bimestre = '') => {
    //isActionMassive.value = true
    guardarTodo = 1
    let buttons = document.getElementsByName('buttonssave' + bimestre);
    //let count = 0
    //let lastIt = buttons.length - 1
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].click();
    }
}

const haveEAP = ref(0)
const arrayAdmisionPuntaje = ref([])
const listarAdmisionPuntaje = () => {
    let url = '/admisionpuntaje/student?id_student=' + props.object.id + '&anioSearch=' + anioSearch.value;
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayAdmisionPuntaje.value = respuesta.admisionpuntajes;
        haveEAP.value = respuesta.haveEAP;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    });
}

/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

const backLink = ref(props.back_link ? '/#' + props.back_link : '')

// Traducir textos
const trans = ref() // <-- Transformar objecto reactivo
const langs = () => {
    let url = '/lang/traducir?id_level=' + (props.object ? (props.object.level ? props.object.level.id : 0) : 0);
    axios.get(url).then((response) => {
        let respuesta = response.data;
        console.log(respuesta);
        if (respuesta) {
            trans.value = respuesta;
        }
    }).catch((error) => {
        console.log(error);

    });
}

/**
 * Listar financiera record de pagos
 */

const arrayPayes = ref([]);
const arrayPayesCol = ref([]);
const numPayePdt = ref(0);
const listarPayes = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/students/listpayes?id_student=' + props.object.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayPayes.value = respuesta.datalist;
        arrayPayesCol.value = respuesta.columnas;
        //console.log(arrayPayes.value);
        if(arrayPayes.value) {
            numPayePdt.value = arrayPayes.value.filter(item => item.status === 1).length;
        }
    }).catch(function (error) {
        console.log(error);
    });
}

const fechaEmision = ref()
const fechaVencimiento = ref('')
const orderVariosLabel = ref('')
const orderVariosAmount = ref(0)
const orderVariosNotify = ref(true)
const errorOrderVarios = ref('')
const iniciarOrdenPagoVarios = () => {

    let id_student = props.object.id
    let fecha_emision = fechaEmision.value
    let fecha_vencimiento = fechaVencimiento.value
    let label = orderVariosLabel.value
    let amount = orderVariosAmount.value
    let notify = orderVariosNotify.value
    let typeOrder = 0

    if (label && amount) {
        let formOrdenPago = {
            'id_student': id_student,
            'fecha_emision': fecha_emision,
            'fecha_vencimiento': fecha_vencimiento,
            'label': label,
            'amount': amount,
            'notify': notify,
            'tipo_de_order': typeOrder,
            'id_order_origen': 0
        };

        let url = '/payementOrder/registrarvarios';
        axios.post(url, formOrdenPago).then((response) => {
            let respuesta = response.data;
            //arrayOrdenPago.value = respuesta.datalist;
            //arrayOrdenPagoCol.value = respuesta.columnas;
            if (respuesta.success) {
                showAlert(respuesta.message, 'success', 4)
                listarPayes()
                //console.log(response)
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }
            console.log('response payement varios');
            //console.log(arrayOrdenPago.value);
        }).catch((error) => {
            console.log(error);

        });
    } else {
        errorOrderVarios.value = 'Error'
    }

}

/**
 * Procesar archivos adjuntos
 */
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const listarDocumentos = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_document_student?src_object_id=' + props.object.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const documentNotify = ref(true)
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_document_student') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    let notify = documentNotify.value
    if (type == 'file_document_student') {
        file = fileDocument.value.files[0];
        origin_id = props.object.id
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    data.append('notify', notify)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_document_student') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                listarDocumentos()
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
}

const selectedField = ref([])
const modoUpdateLine = ref(false)
const updateStory = (id, object = []) => {
    if (id) {
        let formOrdenPago = {
            'id': id,
            'id_level': object['id_level'],
            'id_classroom': object['id_classroom'],
            'id_classroom_matricula': object['id_classroom_matricula'],
            'id_classroom_ugel': object['id_classroom_ugel'],
            'student_status': object['student_status']
        };

        let url = '/student/story/updatestory';
        axios.put(url, formOrdenPago).then((response) => {
            let respuesta = response.data;
            if (respuesta.success) {
                showAlert(respuesta.message, 'success', 4)
                //console.log(response)
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }
            console.log('Actualizar historia');
        }).catch((error) => {
            console.log(error);

        });
    } else {
        alert('Sin ID Story')
        console.log(object)
    }
}

// keypress detecta Tab como si fuera Enter ahora usar -> keydown para detectar otras teclas como Ctrl y diferencia el Tab
document.addEventListener('keydown', function (evt) {
    //console.log(evt)
    // Si el evento NO es una tecla Enter
    if (evt.key !== 'Enter' && evt.key !== 'Control') {
        return;
    }

    let element = evt.target;

    // Si el evento NO fue lanzado por un elemento con class "focusNext"
    if (!element.classList.contains('focusNext')) {
        return;
    }

    // AQUI logica para encontrar el siguiente debajo
    let tabIndexOrigin = element.tabIndex;
    let tabIndexNext = tabIndexOrigin;

    // En algunos navegadores el Enter y Tab hacen los mismo con keypress pero ahora usaremos keydown
    if (evt.key === 'Enter') {
        tabIndexNext = tabIndexNext + 1;
    } else if (evt.key === 'Control') {
        // Tab
        tabIndexNext = tabIndexNext + 100; // Encontra al lado derecho pues crece de 100 en 100
    }
    
    //console.log(element.value)
    // si la nota es inconsistencia mostrar alerta
    let inconsistencia = alertMinMax(element.value, 0)
    if (inconsistencia) {
        tabIndexNext = tabIndexOrigin
    }
    
    //console.log(tabIndexNext)
    var next = document.querySelector('[tabindex="' + tabIndexNext + '"]');

    // Si encontramos un elemento
    if (next) {
        next.focus();
        // No es neceasrio qye no usamos un form
        //Event.preventDefault();
    }
});

// Instancia para acceder a propiedades globales
const internalInstance = getCurrentInstance();

// Constantes de nota mínima y máxima
const notaMinimaInput = computed(() => {
    const pageProps = usePage()?.props?.value;
    const cGlobal = internalInstance?.proxy?.confGlobal?.value || pageProps?.confGlobal;
    const minVal = cGlobal?.CALIFICATION_NOTA_MINIMA_INPUT;
    return (minVal !== undefined && minVal !== null && minVal !== '') ? Number(minVal) : 8;
});

const notaMaximaInput = computed(() => {
    const pageProps = usePage()?.props?.value;
    const cGlobal = internalInstance?.proxy?.confGlobal?.value || pageProps?.confGlobal;
    const maxVal = cGlobal?.CALIFICATION_NOTA_MAXIMA_INPUT;
    return (maxVal !== undefined && maxVal !== null && maxVal !== '') ? Number(maxVal) : 20;
});

// Forzar mínimo y maximo del input
const alertMinMax = (el, showAlert=1) => {
    let val = (el && typeof el === 'object' && 'value' in el) ? el.value : el;
    let nota = Number(val);
    const min = notaMinimaInput.value;
    const max = notaMaximaInput.value;
    if (val === '' || isNaN(nota) || nota < min || nota > max) {
        if (showAlert) {
            alert(`Inconsistencia en los límites de notas. Debe estar en el rango de ${min} a ${max}.`);
        }
        return 1;
    } else {
        return 0;
    }
};

const hasParcial2Active = computed(() => {
    if (tabCalif.value === 0) return props.existParcial2B1;
    if (tabCalif.value === 1) return props.existParcial2B2;
    if (tabCalif.value === 2) return props.existParcial2B3;
    if (tabCalif.value === 3) return props.existParcial2B4;
    return false;
});

const isNotaInvalida = (nota) => {
    if (nota === null || nota === undefined || String(nota).trim() === '') return false;
    let n = Number(nota);
    const min = notaMinimaInput.value;
    const max = notaMaximaInput.value;
    return isNaN(n) || n < min || n > max;
};

const hasInvalidGrades = computed(() => {
    return arrayCalifications.value.some(cal => {
        return (trans.value?.criterio1 && isNotaInvalida(cal.criterio1)) ||
            (trans.value?.criterio2 && isNotaInvalida(cal.criterio2)) ||
            (trans.value?.criterio3 && isNotaInvalida(cal.criterio3)) ||
            (trans.value?.criterio4 && isNotaInvalida(cal.criterio4)) ||
            (trans.value?.criterio5 && isNotaInvalida(cal.criterio5)) ||
            (trans.value?.criterio6 && isNotaInvalida(cal.criterio6)) ||
            isNotaInvalida(cal.examen_parcial) ||
            (hasParcial2Active.value && isNotaInvalida(cal.examen_parcial2)) ||
            isNotaInvalida(cal.examen_final);
    });
});
</script>

<template>
    <Head :title="object ? object.person.apellidos + ' ' + object.person.nombres : 'Nuevo estudiante'" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>

            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 py-4 border-b dark:border-slate-700/50">
                <div v-if="action != 'create'" class="flex overflow-x-auto gap-2 bg-slate-100/80 dark:bg-slate-800/80 p-1.5 rounded-2xl w-max max-w-full custom-scrollbar">
                    <!-- Tab 0: Estudiante -->
                    <button @click="(tab = 0), (action = 'view')"
                            class="tab-btn-premium"
                            :class="tab == 0 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:user" class="w-4 h-4" />
                            Estudiante
                        </span>
                    </button>
                    <!-- Tab 1: Contacto/Apoderado -->
                    <button @click="(tab = 1), (action = 'view_apoderado')"
                            class="tab-btn-premium"
                            :class="tab == 1 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:users" class="w-4 h-4" />
                            Contacto/Apoderado
                            <span class="px-1.5 py-0.5 text-xs bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-400 rounded-lg">{{ apoderados.length }}</span>
                        </span>
                    </button>
                    <!-- Tab 2: Calificaciones -->
                    <button @click="(tab = 2)"
                            class="tab-btn-premium"
                            :class="tab == 2 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:award" class="w-4 h-4" />
                            Calificaciones
                        </span>
                    </button>
                    <!-- Tab 3: Agenda -->
                    <button @click="(tab = 3)"
                            class="tab-btn-premium"
                            :class="tab == 3 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:calendar" class="w-4 h-4" />
                            Agenda
                        </span>
                    </button>
                    <!-- Tab 4: Historia -->
                    <button @click="(tab = 4)"
                            class="tab-btn-premium"
                            :class="tab == 4 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:history" class="w-4 h-4" />
                            Historia
                            <span class="px-1.5 py-0.5 text-xs bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-400 rounded-lg">{{ stories.length }}</span>
                        </span>
                    </button>
                    <!-- Tab 6: Estado de cuenta -->
                    <button v-if="isAdmin || isSecre"
                            @click="(tab = 6, listarPayes())"
                            class="tab-btn-premium"
                            :class="tab == 6 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:credit-card" class="w-4 h-4" />
                            Estado de cuenta
                            <span v-if="numPayePdt" class="px-1.5 py-0.5 text-xs bg-amber-500 text-white rounded-lg font-bold" title="Pendientes de pago">{{ numPayePdt }}</span>
                        </span>
                    </button>
                    <!-- Tab 5: Documentos -->
                    <button @click="(tab = 5, listarDocumentos())"
                            class="tab-btn-premium"
                            :class="tab == 5 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:folder" class="w-4 h-4" />
                            Documentos
                        </span>
                    </button>
                    <!-- Tab 7: Log -->
                    <button @click="(tab = 7)"
                            class="tab-btn-premium"
                            :class="tab == 7 ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'">
                        <span class="flex items-center gap-2">
                            <Icon icon="tabler:clipboard-list" class="w-4 h-4" />
                            Log
                        </span>
                    </button>
                </div>

                <div v-else class="flex items-center">
                    <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">Nuevo estudiante</h3>
                </div>

                <div v-if="action == 'view_apoderado' && canWrite && tab == 1" class="flex items-center">
                    <button @click="action = 'create_apoderado'" class="btn-premium-primary w-full md:w-auto">
                        <Icon icon="tabler:plus" class="w-4 h-4" />
                        <span>Crear Contacto</span>
                    </button>
                </div>
            </div>


            <BreezeValidationErrors class="mb-4 mt-4" />

            <!-- In basebutton: @click="route('dashboard')"-->

            <!--<Link :href="route('student-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>

                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->

        </template>

        <div>
                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <div v-if="object && action != 'create' && action != 'edit'" class="bg-white shadow-lg border rounded-md p-2 lg:p-4 mb-4" >
                    <div class="flex justify-between items-center">
                        <div>
                            <div class="flex items-center justify-center">
                                <BaseIcon :path="mdiSchool" :size="26" class=" lg:inline-flex hidden text-blue-500 mr-3" />
                                <span class="lg:text-base text-xs font-semibold">
                                    {{ object.person.apellidos + ' ' + object.person.nombres }}
                                </span>
                            </div>
                        </div>
                        <div v-if="object" class="text-right">
                            <div class="flex items-center justify-center">
                                <span class="lg:text-sm text-xs" :class="'inline-block px-2 py-1 text-white ' + (object.status == 0 ? 'bg-red-500' : (object.status == 3 ? 'bg-gray-500' : (object.status == 1 ? 'bg-green-500' : 'bg-yellow-500'))) + ' rounded-md'">
                                    <span v-if="object.status == 0">Retirado</span>
                                    <span v-else-if="object.status == 1">Activo</span>
                                    <span v-else-if="object.status == 2">Ingresante</span>
                                    <span v-else-if="object.status == 3">Egresado</span>
                                    <span v-else-if="object.status == 4">Ingresante Vacacional</span>
                                    <span v-else-if="object.status == -1">Promovido</span>
                                    <span v-else></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="(tab == 0)">

                    <template v-if="action == 'view' && object">

                        <div class="grid gap-4">
                            <div class="grid grid-cols-1 sm:grid-cols-4 xl:grid-cols-8 gap-4">
                                <div class="sm:col-span-4 lg:col-span-4 bg-white rounded-md shadow-lg p-4 border h-full my-auto lg:max-h-[324px]">
                                    <div class="flex flex-col lg:flex-row gap-4 h-full">
                                        <div class="flex items-center">
                                            <img class="max-h-[150px] lg:max-h-[292px] rounded-lg border-2 border-gray-600" :src="object.person.sexo ? '/img/student/boy.png' : '/img/student/girl.png'">
                                        </div>
                                        <div>
                                            <div class="flex items-center h-full justify-start">
                                                <div>
                                                    <span class="text-lg font-medium">{{
                                                        object.person.apellidos + ' ' + object.person.nombres
                                                    }}</span><br>
                                                    <span class="font-medium mr-2">{{ object.person.id_type_document ? typeDocuments.find(item => item.id === object.person.id_type_document).label : '' }} : </span>{{ object.person.num_doc }}
                                                    <br>
                                                    <span class="font-medium mr-2">Género : </span>{{ object.person.sexo ?
                                                        'Masculino' :
                                                        'Femenino'
                                                    }}<br>
                                                    <span class="font-medium mr-2">Teléfono : </span> {{
                                                        object.person.telefono
                                                    }}, celular : {{ object.person.celular }}<br>
                                                    <span class="font-medium mr-2">Email : </span> {{ object.person.email }}<br>
                                                    <span class="font-medium mr-2">Dirección : </span> {{
                                                        object.person.domicilio
                                                    }}, distrito : {{ object.person.id_distrito_domicilio ? distritos.find(item => item.id === object.person.id_distrito_domicilio).label : '' }}
                                                    <br>
                                                    <!-- <span class="font-medium mr-2">Código interno (user) : </span>
                                                    {{ user.user }}
                                                    <br> -->
                                                    <span class="font-medium mr-2">Login Usuario : </span>
                                                    {{ user.email }}
                                                    <br>
                                                    <span class="font-medium mr-2">Login PAssword : </span>
                                                    {{ object.person.num_doc }}
                                                    <small>DNI por defecto, Si el usuario cambió su clave, puede restablecer los datos de Login</small>
                                                    <!-- Referencia : {{ object.person.referencia }} -->
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="sm:col-span-4 lg:col-span-1 my-auto bg-rose-600 rounded-md shadow-lg p-6 h-full text-center flex justify-center items-center lg:max-h-[324px]">
                                    <div>
                                        <p class="text-white font-bold text-center">Clase</p>
                                        <p class="text-[30px] lg:text-[50px] text-white font-bold leading-normal text-center">
                                            {{ object.level ? object.level.label_short : '' }}</p>
                                        <p class="text-white font-bold text-center">{{ object.classroom ? object.classroom.label : '' }}</p>
                                    </div>

                                </div>
                                <div class="sm:col-span-4 lg:col-span-3">
                                    <div class="grid grid-cols-1 lg:flex flex-col gap-4 w-full">
                                        <div class="flex flex-row rounded-md border bg-white shadow-lg w-full">
                                            <div><img class="object-cover rounded-l-md max-h-[140px] md::max-h-[180px] lg:max-h-[244px]" src="/img/student/tutor.png" alt="" /></div>
                                            <div class="p-6 flex flex-col">
                                                <div class="flex items-center h-full justify-start">
                                                    <div>
                                                        <h3 class="text-gray-900 text-xl font-medium mb-2">
                                                            <!-- Tutor -->
                                                        </h3>
                                                        <p class="text-gray-700 text-base">
                                                            <!-- lorem lorem -->
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="flex justify-center w-full h-full">
                                            <div class="flex flex-row w-full  rounded-md shadow-lg relative my-auto h-auto border">
                                                <div class="basis-1/2 md:h-auto my-auto object-cover rounded-l-md bg-white p-4">

                                                    <span class="text-gray-800 text-base 2xl:text-lg font-semibold">Fecha de Matricula</span>
                                                </div>
                                                <div class="basis-1/2 p-4 text-center w-full bg-gray-100 rounded-r-md">
                                                    <div class="flex w-full  items-center h-full justify-center">
                                                        <p class="text-lg font-semibold text-gray-900 ">
                                                            {{ object.fecha_matricula }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-4">
                                    <div class="col-span-1 md:col-span-2 lg:col-span-5 lg:max-h-[534px]">
                                        <div class="bg-white shadow-lg border rounded-md p-4">
                                            <h2 class="mb-3">Detalles Personales</h2>

                                            <div class="grid lg:grid-cols-2 md:grid-cols-2 gap-2">
                                                <!--<div
                                                        class="flex items-star justify-between rounded-md mb-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                                        <div class="flex gap-3">
                                                            <div>
                                                                <div
                                                                    class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-sky-500 focus:shadow-outline hover:bg-sky-700">
                                                                    <BaseIcon :path="mdiPill" :size="24" />
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <h3 class="font-medium text-lg">Referencia de domicilio</h3>
                                                                <p class="text-sm pt-0.5">Vive en el algun
                                                                    lugar{{ object.person.referencia }}</p>
                                                            </div>
                                                        </div>
                                                    </div>-->
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-sky-500 rounded-lg focus:shadow-outline hover:bg-sky-700">
                                                        <BaseIcon :path="mdiHomeSearch" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Referencia de domicilio</p>
                                                        <div class="text-sm">
                                                            {{ object.person.referencia }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-lime-500 rounded-lg focus:shadow-outline hover:bg-lime-700">
                                                        <BaseIcon :path="mdiCradle" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Fecha de nacimiento</p>
                                                        <div class="text-sm"> {{ object.person.fecha_nacimiento }}, Distrito : {{
                                                            object.person.id_distrito_nacimiento ? distritos.find(item =>

                                                                item.id === object.person.id_distrito_nacimiento).label : ''
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-rose-500 rounded-lg focus:shadow-outline hover:bg-rose-700">
                                                        <BaseIcon :path="mdiTownHall" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Colegio de procedencia</p>
                                                        <div class="text-sm">
                                                            {{ object.id_colegio_procedencia ? colegios.find(item =>
                                                                item.id ===
                                                                object.id_colegio_procedencia).label : ''
                                                            }}
                                                            Distrito {{ object.id_distrito_colegio ?
                                                                distritos.find(item =>
                                                                    item.id === object.id_distrito_colegio).label : ''
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                        <BaseIcon :path="mdiCross" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Religión </p>
                                                        <div class="flex flex-row text-sm">
                                                            <div>{{ object.id_religion ? religions.find(item => item.id === object.id_religion).label :
                                                                ''
                                                            }}
                                                            </div>
                                                            <div> Exonerado? {{ object.exonerado_religion ? 'Si' : 'No' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-yellow-400 rounded-lg focus:shadow-outline hover:bg-yellow-600">
                                                        <BaseIcon :path="mdiPill" :size="28" />
                                                    </button>
                                                    <div>
                                                        <p class="text-sm font-semibold">Alergia a algún medicamento?</p>
                                                        <div class="text-sm"> {{ object.alergia ?? 'No' }}</div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-green-500 rounded-lg focus:shadow-outline hover:bg-green-700">
                                                        <BaseIcon :path="mdiMedicalBag" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Alguna enfermedad a considerar
                                                        </p>
                                                        <div class="text-sm"> {{ object.enfermedad ?? 'No' }} </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-fuchsia-500 rounded-lg focus:shadow-outline hover:bg-fuchsia-700">
                                                        <BaseIcon :path="mdiGymnastics" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">¿Apto para educación física?</p>
                                                        <div class="text-sm"> {{ object.apto_edu_fisica ? 'Si' : 'No' }}</div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-red-600 rounded-lg focus:shadow-outline hover:bg-red-800">
                                                        <BaseIcon :path="mdiWater" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">¿Tamisaje de hemoglobina? </p>
                                                        <div class="text-sm">
                                                            {{ object.tamisaje_hemoglobina ?
                                                                'Realizado y entregado' :
                                                                'Pendiente con compromiso'
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-orange-400 rounded-lg focus:shadow-outline hover:bg-orange-700">
                                                        <BaseIcon :path="mdiPuzzleRemove" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Problemas de aprendizaje</p>
                                                        <div class="flex flex-row text-sm"> {{ object.obs_aprendizaje ?? 'No' }}</div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-amber-400 rounded-lg focus:shadow-outline hover:bg-amber-600">
                                                        <BaseIcon :path="mdiCheckDecagram" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Tipo</p>
                                                        <div class="text-sm">
                                                            {{ object.type ? 'Antiguo' : 'Nuevo' }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                        <BaseIcon :path="mdiCreditCardOutline" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Estado financiero</p>
                                                        <div class="text-sm">{{ object.status_financiero ? 'Al día' : 'Pago pendiente'
                                                        }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="hover:bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <button class="inline-flex items-center justify-center w-11 h-11 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                        <BaseIcon :path="mdiInformationOutline" :size="28" />
                                                    </button>
                                                    <div class="grid content-between h-11">
                                                        <p class="text-sm font-semibold">Log</p>
                                                        <div class="text-sm">Modif. Card: {{ user_modif ? user_modif.name : '' }} {{
                                                            object.updated_at ? formatDateTime(object.updated_at) : '' }} {{ user_modif_status ? 'Modif. Status:' + user_modif_status.name : '' }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Otra información -->
                                                <div class="bg-gray-100 flex items-center rounded-md p-1">
                                                    <div>
                                                        <span class="font-medium mr-2">Código UGEL : </span>{{ object.ref_ugel }}<br>
                                                        <span class="font-medium mr-2">Fecha de retiro : </span>{{ object.fecha_retiro ? formatDate(object.fecha_retiro) : '' }}<br>
                                                        <span class="font-medium mr-2">Fecha de reingreso : </span>{{ object.fecha_reingreso ? formatDate(object.fecha_reingreso) : '' }}<br>
                                                        <span class="font-medium mr-2">Nota : </span>{{ object.note }}
                                                    </div>
                                                </div>
                                                <div v-if="$page.props.auth.user.id_rol <= 4" class="bg-gray-100 flex items-center rounded-md p-1 space-x-3">
                                                    <div>
                                                        <span class="font-medium mr-2">Pensión preferencial : </span>{{ object.pension_preferencial }}<br>
                                                        <span class="font-medium mr-2">Becado : </span>{{ object.becado ? 'Si' : 'No' }}<br>
                                                        <span class="font-medium mr-2">Compromiso de pago : </span>{{ object.fecha_compromiso_pago ? formatDate(object.fecha_compromiso_pago) : '' }}<br>
                                                        <span class="font-medium mr-2">Nota Financiera : </span>{{ object.financial_note }}

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-span-1 md:col-span-2 lg:col-span-3">
                                        <div class="bg-white shadow-lg border rounded-md p-4 h-full ">
                                            <div class="flex flex-col items-center h-full w-full justify-center">
                                                <div class="w-full justify-between flex">
                                                    <h2 class="mb-2 inline-block">Gráfica de competencias
                                                    </h2>
                                                    <div>
                                                        <select v-model="chartSelectCiclo" @change="listarChartCalification(chartSelectCiclo)">
                                                            <option value="" disabled>Escoja el Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'" selected>Primer Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'" selected>Segundo Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'" selected>Tercer Bimestre</option>
                                                            <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'" selected>Cuarto Bimestre</option>
                                                        </select>
                                                    </div>
                                                    
                                                </div>
                                                <div class="flex items-center w-full h-full">
                                                    <CardBox class="w-full xl:h-[420px]">
                                                        <!-- {{ chartCalifications }} -->
                                                        <div v-if="chartCalifications">
                                                            <CompetencyGraphic :data="chartCalifications" heightClass="h-[316px] xl:h-[380px]" /><!-- class="h-96" con w-full no queda muy bien -->
                                                        </div>
                                                        <div v-else>
                                                            No existen notas ...
                                                        </div>
                                                    </CardBox>
                                                </div>
                                                <!--{{ chartCompetencias }}-->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-if="canWrite" class="flex justify-end">
                                <!-- Aceso desde AdminCoord -->
                                <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                <div class="col-span-1">
                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                        label=" Modificar" class="w-full" />
                                                </div>
                                                <div class="col-span-1">
                                                    <BaseButton v-if="object.status" color="danger"
                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                <div class="">
                                    <div class="grid lg:grid-cols-2 gap-4"><!-- <-- cols-4 para cuatro botones o 3  -->
                                        <!-- <div class="col-span-1">
                                                <BaseButton color="info" :icon="mdiPencil"
                                                    label=" Modificar" class="w-full" />
                                            </div>
                                            <div class="col-span-1">
                                                <BaseButton color="success" :icon="mdiPencil" 
                                                    label=" Modificar" class="w-full" />
                                            </div> -->
                                        <div class="col-span-1">
                                            <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'" label=" Modificar" class="w-full" />
                                        </div>
                                        <div class="col-span-1">
                                            <BaseButton v-if="object.status" color="danger" @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                            <BaseButton v-else color="success" :icon="mdiCheckCircle" @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- Editar -->
                    <template v-else-if="action == 'edit' && canWrite">
                        <div class="bg-white overflow-hidden shadow-lg border rounded-md p-4">
                            <h3 class="md:text-2xl text-xl my-4 font-medium">Modificar</h3>
                            <form @submit.prevent="submit">
                                <FormField label="Apellidos y Nombres">
                                    <FormControl v-model="form.apellidos" name="apellidos" type="text" required />
                                    <FormControl v-model="form.nombres" name="nombres" type="text" required />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Fecha de matrícula / Documento">
                                    <FormControl v-model="form.fecha_matricula" type="date" />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="form.num_doc" name="num_doc" type="text" required />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="form.domicilio" name="direccion" type="text" placeholder="Dirección" />
                                    <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="form.referencia" name="referencia_domicilio" type="text" placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="form.fecha_nacimiento" type="date" />
                                    <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de estudiante -->
                                <FormField label="Sede/Colegio de procedencia">
                                    <FormControl v-model="form.sede_origen" type="select" :options="sedes" placeholder="Sede Origen" />
                                    <FormControl v-model="form.id_colegio_procedencia" type="select" :options="colegios" placeholder="Colegios" />
                                    <FormControl v-model="form.id_distrito_colegio" type="select" :options="distritos" placeholder="Distrito" />
                                </FormField>
                                <FormField label="Religión / Exonerado" help="Detalle si congrega una religión y si desea ser exonerado del curso de religión">
                                    <FormControl v-model="form.id_religion" type="select" :options="religions" placeholder="Escoja una Religión" />
                                    <FormControl v-model="form.exonerado_religion" type="yesno" placeholder="exonerado" />
                                </FormField>
                                <FormField label="Datos de salud del estudiante" help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                    <FormControl v-model="form.alergia" type="text" labelinput="Alérgico a algun medicamento" />
                                    <FormControl v-model="form.enfermedad" type="text" labelinput="Alguna enfermedad a considerar" />
                                    <FormControl v-model="form.apto_edu_fisica" type="yesno" placeholder="es apto" labelinput="Apto para educación física" />
                                    <FormControl v-model="form.tamisaje_hemoglobina" type="select" :options="optionsTamizaje" placeholder="Escoja una opción" labelinput="Tamizaje de hemoglobina" />
                                </FormField>
                                <FormField label="Vacunas" help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                    <FormControl v-model="form.vacuna_pentavalente" type="yesno" placeholder="está vacunado" labelinput="Pentavalente" />
                                    <FormControl v-model="form.vacuna_odpt" type="yesno" placeholder="está vacunado" labelinput="O DPT" />
                                </FormField>
                                <FormField label="Otros casos a considerar">
                                    <FormControl v-model="form.obs_aprendizaje" type="text" labelinput="Problemas de aprendizaje" />
                                    <FormControl v-model="form.aprendizaje_terapia" type="yesno" placeholder="está en terapia" labelinput="Terapia" />
                                    <FormControl v-model="form.obs_otros" type="text" labelinput="Otros" />
                                </FormField>
                                <FormField label="Seguro de salud" :help="form.obs_seguro_salud = selectSeguroSalud + ' : ' + textSeguroSalud">
                                    <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud" />
                                    <FormControl v-model="textSeguroSalud" type="text" :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional'" />
                                </FormField>
                                <FormField label="Situación familiar" :help="form.obs_situacion_familiar = selectSituacionFamiliar + ' : ' + textSituacionFamiliar">
                                    <FormControl v-model="selectSituacionFamiliar" type="select" :options="optionsSituacionFamiliar" />
                                    <FormControl v-model="textSituacionFamiliar" type="text" :placeholder="selectSituacionFamiliar == optionsSituacionFamiliar[0] ? 'Cantidad de hermanos' : (selectSituacionFamiliar == optionsSituacionFamiliar[3] ? 'Especificar' : 'Información opcional')" />
                                </FormField>
                                <FormField label="Datos de la vivienda" :help="form.obs_datos_vivienda = selectVivienda + ' : ' + textVivienda">
                                    <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" />
                                    <FormControl v-model="textVivienda" type="text" placeholder="Información adicional" />
                                </FormField>

                                <FormField label="Estado civil de los padres">
                                    <FormControl v-model="form.id_estado_civil_padres" type="select" :options="estadoCiviles" placeholder="Escoja una opción" />
                                    <FormControl v-model="form.obs_estado_padres" type="text" placeholder="Observación adicional" />
                                </FormField>
                                <FormField label="Datos académicos">
                                    <FormControl v-model="form.id_level" type="select" :options="levels" placeholder="Escoja una opción" labelinput="Nivel/Grado de estudio" />
                                    <FormControl v-model="form.id_classroom" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula de estudio" />
                                    <FormControl v-model="form.id_classroom_matricula" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula matrícula" />
                                    <FormControl v-model="form.id_classroom_ugel" type="select" :options="teoricClassrooms" placeholder="Aula en SIAGIE" labelinput="Aula Ugel" canBeNull />
                                </FormField>
                                <FormField label="">
                                    <FormControl v-model="form.ref_ugel" type="text" labelinput="Código UGEL" />
                                    <FormControl v-model="form.fecha_retiro" type="date" labelinput="Fecha retiro" />
                                    <FormControl v-model="form.fecha_reingreso" type="date" labelinput="Fecha reingreso" />
                                </FormField>
                                <FormField label="Modalidad Vacacional" :class="(confGlobal.value.VACACIONAL_MODE_ACTIVE == 1 ? 'text-blue-600' : 'hidden')">
                                    <FormControl v-model="form.fecha_matricula_vacacional" type="date" labelinput="Matrícula Vacacional" />
                                    <FormControl v-model="form.id_level_vacacional" type="select" :options="levelsvacacional" placeholder="Escoja una opción" labelinput="Nivel Vacacional" />
                                    <FormControl v-model="form.id_classroom_vacacional" type="select" :options="classroomsvacacional" placeholder="Escoja una opción" labelinput="Aula Vacacional" />
                                </FormField>
                                <FormField label="Nota">
                                    <FormControl v-model="form.note" type="textarea" labelinput="Otra información" />
                                </FormField>
                                <!-- No mostrar a secretaria -->
                                <FormField :hidden="$page.props.auth.user.id_rol == 6" label="Financiera">
                                    <FormControl v-model="form.financial_note" type="textarea" labelinput="Nota financieras" />
                                    <FormControl v-model="form.pension_preferencial" type="number" labelinput="Pensión preferencial" :tooltipcontent="'Ingresar un monto si tiene pensión preferencial'" />
                                    <FormControl v-model="form.becado" type="yesno" labelinput="Becado?" :tooltipcontent="'No se genera órdenes de pago'" />
                                    <FormControl v-model="form.fecha_compromiso_pago" type="date" labelinput="Fecha de compromiso de pago" />
                                </FormField>
                                <FormField :hidden="$page.props.auth.user.id_rol == 6" label="Restablecer datos de Login"><!-- :isoneintwo="true" -->
                                    <FormControl v-model="form.change_login" type="yesno" labelinput="Cambiar email y password por defecto?" :tooltipcontent="'Por defecto el usuario es DOCUMENTO' + confGlobal.value.USER_EMAIL_DEFAULT_SUFIJO + ' y el password es el DOCUMENTO'" />

                                </FormField>

                                <div class="flex items-center justify-end mt-4">
                                    <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                    <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>

                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear sólo desde el botón return dashboard-->
                    <template v-else-if="action == 'create'">
                        <div class="grid grids-col-1 gap-3 bg-white shadow-lg border rounded-md p-4">
                            <h2>Agregar nuevo estudiante</h2>
                            <form @submit.prevent="submit">
                                <!-- :class="(confGlobal.value.VACACIONAL_MODE_ACTIVE == 1 ? 'text-blue-600' : 'hidden')" -->
                                <FormField label="Tipo de Ingreso">
                                    <FormControl v-model="form.status" type="select" :options="(confGlobal.value.VACACIONAL_MODE_ACTIVE == 1 ? optionsTipoIngresoVaca : optionsTipoIngreso)" placeholder="Tipo de Ingreso" />
                                </FormField>
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="form.apellidos" name="apellidos" type="text" required placeholder="Apellidos" />
                                    <FormControl v-model="form.nombres" name="nombres" type="text" required placeholder="Nombres" />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Fecha de matrícula / Documento" required>
                                    <FormControl v-model="form.fecha_matricula" type="date" />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="form.num_doc" name="num_doc" type="text" required />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="form.telefono" name="telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" name="celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.email" name="email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>
                                <FormField label="Modalidad Vacacional" :class="(form.status == 4 ? 'text-blue-600' : 'hidden')">
                                    <FormControl v-model="form.fecha_matricula_vacacional" type="date" labelinput="Matrícula Vacacional" />
                                    <FormControl v-model="form.id_level_vacacional" type="select" :options="levelsvacacional" placeholder="Escoja una opción" labelinput="Nivel Vacacional" />
                                    <FormControl v-model="form.id_classroom_vacacional" type="select" :options="classroomsvacacional" placeholder="Escoja una opción" labelinput="Aula Vacacional" />
                                </FormField>
                                <!-- Sólo si es ingresante regular más datos -->
                                <template v-if="form.status == 2">
                                    <!-- Si no es vacacional crear otras opciones -->
                                    <FormField label="Domicilio">
                                        <FormControl v-model="form.domicilio" name="direccion" type="text" placeholder="Dirección" />
                                        <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                        <FormControl v-model="form.referencia" type="text" placeholder="Referencia de domicilio" />
                                    </FormField>

                                    <FormField label="Datos de nacimiento">
                                        <FormControl v-model="form.fecha_nacimiento" type="date" />
                                        <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                    </FormField>

                                    <!-- Datos de estudiante -->
                                    <FormField label="Sede/Colegio de procedencia">
                                        <FormControl v-model="form.sede_origen" type="select" :options="sedes" placeholder="Sede Origen" />
                                        <FormControl v-model="form.id_colegio_procedencia" type="select" :options="colegios" placeholder="Colegios" />
                                        <FormControl v-model="form.id_distrito_colegio" type="select" :options="distritos" placeholder="Distrito" />
                                    </FormField>

                                    <!-- Datos académicos -->
                                    <FormField label="Datos académicos">
                                        <FormControl v-model="form.id_level" type="select" :options="levels" placeholder="Escoja una opción" labelinput="Nivel/Grado de estudio" />
                                        <FormControl v-model="form.id_classroom" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula de estudio" />
                                        <FormControl v-model="form.id_classroom_matricula" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula matrícula" />
                                        <FormControl v-model="form.id_classroom_ugel" type="select" :options="teoricClassrooms" placeholder="Escoja una opción" labelinput="Aula Ugel" />
                                    </FormField>
                                    <FormField v-if="confGlobal.value.FINANCIERA_CREAR_ORDEN_PAGO_TO_CREAR_STUDENT == 1" label="Datos financieros">
                                        <FormControl v-model="form.becado" type="yesno" labelinput="Becado? No se realizará seguimientos de pagos" />
                                    </FormField>

                                    <!-- Crear orden de pago -->
                                    <div v-if="confGlobal.value.FINANCIERA_CREAR_ORDEN_PAGO_TO_CREAR_STUDENT == 1 && form.becado == 0" class="my-auto inline-flex items-center">
                                        <span class="inline-flex font-semibold text-yellow-600" @click="form.crear_orden_pago = !form.crear_orden_pago">
                                            <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                            Crear órdenes para el seguimiento de pagos [+]
                                        </span>
                                    </div>
                                    <div v-if="form.crear_orden_pago && form.becado == 0" class="border-l-2 border-yellow-600  bg-white leading-normal p-6">
                                        <div>
                                            <ul>
                                                <li>Asegúrese de la orden de pago sea del año correcto (si se matricula para este año o para el próximo año).</li>
                                                <li>Matrícula inicial: <b>{{ confGlobal.value.PRECIO_MATRICULA_INICIAL }}</b>, Matrícula primaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_PRIMARIA }}</b>,
                                                    Matrícula secundaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_SECUNDARIA }}</b>, Pensión inicial:
                                                    <b>{{ confGlobal.value.PRECIO_PENSION_INICIAL }}</b>, Pensión primaria: <b>{{ confGlobal.value.PRECIO_PENSION_PRIMARIA }}</b>
                                                    , Pensión secundaria: <b>{{ confGlobal.value.PRECIO_PENSION_SECUNDARIA }}</b>
                                                </li>
                                                <li>La pensión preferencial sólo se ingresa si el pago de pensión es distinto al establecido, de lo contrario lo deja en cero</li>
                                            </ul>
                                        </div>
                                        <div class="grid-cols-4 flex items-center my-4">
                                            <div class="relative">
                                                <label class="mr-3" for="orderAnio"> Año </label>
                                                <select id="orderAnio" class="mb-3 rounded-lg mr-3" v-model="form.orderAnio">
                                                    <option :value="anioEscolar">{{ anioEscolar }}</option>
                                                    <option :value="parseInt(anioEscolar) + 1">{{ parseInt(anioEscolar) + 1 }}</option>
                                                </select>
                                            </div>
                                            <div class="relative">
                                                <label class="mr-3" for="pensionPreferencial">Pensión preferencial</label>
                                                <input class="mb-3 rounded-lg" id="pensionPreferencial" v-model="form.pension_preferencial" type="number">
                                            </div>
                                        </div>

                                        <div class="mt-1 w-full label-clean xl:flex flex-row justify-between grid lg:grid-cols-6 sm:grid-cols-2 grid-cols-1">
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmatricula" class="mr-2" v-model="form.order13" />
                                                <label for="chxmatricula" class="">Matricula</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmarzo" class="mr-2" v-model="form.order03" />
                                                <label for="chxmarzo">Marzo</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxabril" class="mr-2" v-model="form.order04" />
                                                <label for="chxabril">Abril</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxmayo" class="mr-2" v-model="form.order05" />
                                                <label for="chxmayo">Mayo</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxjunio" class="mr-2" v-model="form.order06" />
                                                <label for="chxjunio">Junio</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxjulio" class="mr-2" v-model="form.order07" />
                                                <label for="chxjulio">Julio</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxagosto" class="mr-2" v-model="form.order08" />
                                                <label for="chxagosto">Agosto</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxsetiembre" class="mr-2" v-model="form.order09" />
                                                <label for="chxsetiembre">Setiembre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxoctubre" class="mr-2" v-model="form.order10" />
                                                <label for="chxoctubre">Octubre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxnoviembre" class="mr-2" v-model="form.order11" />
                                                <label for="chxnoviembre">Noviembre</label>
                                            </div>
                                            <div class="flex items-center">
                                                <input type="checkbox" id="chxdiciembre" class="mr-2" v-model="form.order12" />
                                                <label for="chxdiciembre">Diciembre</label>
                                            </div>

                                        </div>

                                    </div>
                                </template>
                                <!-- Crear apoderado -->
                                <template v-if="confGlobal.value.STUDENT_CREATE_WITH_CONTACT == 1">
                                    <hr class="py-3">
                                    <h2 class="mb-3">Agregar apoderado <span v-if="confGlobal.value.STUDENT_CREATE_WITH_CONTACT_IS_MANDATORY == 0 || form.status != 2">(opcional)</span></h2>
                                    <span v-if="existeContacto" class="font-semibold text-red-600 leading-tight">Ya existe una persona con el mismo Documento, se agregará esta persona como apoderado!</span>
                                    <FormField label="Apoderado: Parentesco / Documento">
                                        <FormControl v-model="form.contact_id_parentesco" type="select" :options="parentescos" placeholder="Parentesco" />
                                        <FormControl v-model="form.contact_id_type_document" type="select" :options="typeDocuments" />
                                        <FormControl v-model="form.contact_num_doc" name="num_doc" type="text" @change="getContactForDoc(form.contact_num_doc, 1)" />
                                        <FormControl v-model="form.contact_type" type="select" placeholder="Tipo de apoderado" :options="typeContacts" />
                                    </FormField>
                                    <FormField label="Apoderado: Apellidos y Nombres" required>
                                        <FormControl v-model="form.contact_apellidos" name="apellidos" type="text" placeholder="Apellidos" />
                                        <FormControl v-model="form.contact_nombres" name="nombres" type="text" placeholder="Nombres" />
                                        <FormControl v-model="form.contact_sexo" name="genero" type="select" :options="optionsGenero" placeholder="Género" />
                                    </FormField>
                                    <FormField label="Apoderado: Información de contacto / Fecha de nacimiento (opcional)">
                                        <FormControl v-model="form.contact_celular" name="celular" type="tel" placeholder="Celular" />
                                        <FormControl v-model="form.contact_email" name="email" type="email" :icon="mdiMail" placeholder="Email" />
                                        <FormControl v-model="form.contact_fecha_nacimiento" type="date" />
                                    </FormField>
                                    <span v-if="!existeContacto && form.contact_num_doc && !form.contact_apellidos && !form.contact_nombres" class="font-semibold text-red-600 leading-tight">Al apoderado debe ingresar documento, apellidos y nombres!</span>
                                </template>

                                <!-- Action Buttons -->
                                <div class="flex items-center justify-end mt-4">

                                    <!-- <Link :href="route('student')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Volver al listado
                                            </Link> -->
                                    <!-- <BaseButton
                                                color="contrast"
                                                :href="route('student')"
                                                small
                                                label=" Cancelar"
                                                class="ml-4"
                                            /> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>
                                    <span v-if="form.order13 && !form.fecha_matricula" class="ml-3 font-medium text-red-600">Debe asignar fecha de matrícula</span>
                                    <span v-else-if="form.crear_orden_pago && !form.id_level" class="ml-3 font-medium text-red-600">Debe asignar un nivel/grado de estudio</span>
                                    <!-- Si es ingresante regular y el contacto es obligatorio -->
                                    <span v-else-if="form.status == 2 && confGlobal.value.STUDENT_CREATE_WITH_CONTACT == 1 && confGlobal.value.STUDENT_CREATE_WITH_CONTACT_IS_MANDATORY == 1 && !form.contact_num_doc" class="ml-3 font-medium text-red-600">Debe agregar un apoderado</span>
                                    <BreezeButton v-else class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>

                </template>
                <!-- Apoderado -->
                <template v-else-if="(tab == 1)">
                    <template v-if="action == 'view_apoderado'">
                        <!-- <div class="col-span-1 text-right mb-2">
                            <BaseButton color="info" :icon="mdiPlusCircle" @click="action = 'create_apoderado'"
                                label=" Crear Contacto" class="" />
                        </div> -->

                        <div class="grid grid-cols-1 gap-4">
                            <div class="col-span-1" v-for="(contacto, index) in apoderados" :key="contacto.id">
                                <div class="bg-white shadow-lg border rounded-md p-4">
                                    <!-- <h3 class="md:text-2xl text-xl mt-4 mb-4 font-medium">Datos Personales</h3> -->
                                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
                                        <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                            <button class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                <BaseIcon :path="mdiAccountSupervisor" :size="28" />
                                            </button>
                                            <div>
                                                <h3 class="font-semibold text-lg">Parentesco </h3>
                                                <div>{{ contacto.id_parentesco ?
                                                    parentescos.find(item => item.id === contacto.id_parentesco).label
                                                    :
                                                    ''
                                                }}</div>


                                            </div>
                                        </div>
                                        <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                            <button class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-sky-500 rounded-lg focus:shadow-outline hover:bg-sky-700">
                                                <BaseIcon :path="mdiHomeSearch" :size="28" />
                                            </button>
                                            <div>
                                                <h3 class="font-semibold text-lg">Referencia de domicilio</h3>
                                                <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                    <div>{{ contacto.person.referencia }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                            <button class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-lime-500 rounded-lg focus:shadow-outline hover:bg-lime-700">
                                                <BaseIcon :path="mdiCradle" :size="28" />
                                            </button>
                                            <div>
                                                <h3 class="font-semibold text-lg">Fecha de nacimiento</h3>
                                                <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                    <div> {{ contacto.person.fecha_nacimiento }}, Distrito : {{
                                                        contacto.person.id_distrito_nacimiento ? distritos.find(item =>

                                                            item.id === contacto.person.id_distrito_nacimiento).label : ''
                                                    }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid lg:grid-cols-2 md:grid-cols-2 md:gap-4 gap-2">
                                        <div class="col-span-1 h-auto my-auto">
                                            <div class="flex items-center h-full justify-start">
                                                <div>
                                                    <span class="text-lg font-bold">Nombre: </span>{{
                                                        contacto.person.apellidos + ' ' + contacto.person.nombres
                                                    }}<br>
                                                    <span class="font-bold mr-2">{{ contacto.person.id_type_document ? typeDocuments.find(item => item.id === contacto.person.id_type_document).label : '' }} : </span>{{
                                                        contacto.person.num_doc }}
                                                    <br>
                                                    <span class="font-bold mr-2">Género : </span>{{
                                                        contacto.person.sexo ?
                                                        'Masculino' :
                                                        'Femenino'
                                                    }}<br>
                                                    <span class="font-bold mr-2">Teléfono : </span> {{
                                                        contacto.person.telefono
                                                    }}, celular : {{ contacto.person.celular }}
                                                    <a :href="'https://wa.me/+51' + contacto.person.celular + '?text=Hola'" target="_blank">
                                                        <BaseIcon :path="mdiWhatsapp" class="text-green-700" :size="14" />
                                                    </a><br>
                                                    <span class="font-bold mr-2">Email : </span> {{
                                                        contacto.person.email }}<br>
                                                    <span class="font-bold mr-2">Dirección : </span> {{
                                                        contacto.person.domicilio
                                                    }}, distrito : {{
    contacto.person.id_distrito_domicilio ? distritos.find(item =>
        item.id ===
        contacto.person.id_distrito_domicilio).label : ''
}}<br>
                                                    <!-- <span class="font-bold mr-2">Login : </span> 
                                                                {{ user.email }}<br>
                                                                <span class="font-bold mr-2">User : </span> 
                                                                {{ user.user }} (clave default = DNI) -->
                                                    <!-- Referencia : {{ object.person.referencia }} -->
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-span-1 h-auto my-auto">
                                            <div class="flex items-center h-full justify-start">
                                                <div>
                                                    <span class="font-bold mr-2">Tipo : </span>{{
                                                        (contacto.type == 0 ? 'Otro' : (contacto.type == 1 ? 'Responsable de pagos' : (contacto.type == 2 ? 'Responsable de Facturación' : 'Responsable de Pagos y Facturación'))) }}
                                                    <br>
                                                    <span class="font-bold mr-2">Ocupación : </span>{{
                                                        contacto.ocupation }}
                                                    <br>
                                                    <span class="font-bold mr-2">Trabajo : </span>{{
                                                        contacto.trabajo
                                                    }}<br>
                                                    <span class="font-bold mr-2">Horario Laboral : </span>{{
                                                        contacto.horario_laboral
                                                    }}<br>
                                                    <span class="font-bold mr-2">Teléfono Trabajo : </span> {{
                                                        contacto.telefono_trabajo
                                                    }}, celular trabajo : {{ contacto.celular_trabajo }}<br>
                                                    <!-- <span class="font-bold mr-2">Email : </span> {{
                                                            contacto.person.email }}<br> -->
                                                    <span class="font-bold mr-2">Nota : </span> {{
                                                        contacto.note
                                                    }}<!-- , distrito : {{
                                                            contacto.person.id_distrito_domicilio ? distritos.find(item =>
                                                                item.id ===
                                                                contacto.person.id_distrito_domicilio).label : ''
                                                        }}<br> -->
                                                    <!-- <span class="font-bold mr-2">Login : </span> 
                                                                {{ user.email }}<br>
                                                                <span class="font-bold mr-2">User : </span> 
                                                                {{ user.user }} (clave default = DNI) -->
                                                    <!-- Referencia : {{ object.person.referencia }} -->
                                                </div>
                                            </div>
                                        </div>



                                        <!-- <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                            <BaseIcon :path="mdiAccountSupervisor" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Parentesco </h3>
                                                            <div>{{ contacto.id_parentesco ?
                                                                    parentescos.find(item => item.id === contacto.id_parentesco).label :
                                                                    ''
                                                            }}</div>
                                                            
                                                            
                                                        </div>
                                                    </div> -->
                                        <!-- <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                            <BaseIcon :path="mdiInformationOutline" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Log</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>Modif. Card: {{ user_modif ? user_modif.name : '' }} {{ object.updated_at ? formatDateTime(object.updated_at) : '' }} {{ user_modif_status ? 'Modif. Status:'+user_modif_status.name : '' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                    </div>

                                    <div v-if="canWrite" class="flex justify-end"><!-- Secretaria 6 -->
                                        <!-- Aceso desde AdminCoord -->
                                        <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                                <div class="col-span-1">
                                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                                        label=" Modificar" class="w-full" />
                                                                </div>
                                                                <div class="col-span-1">
                                                                    <BaseButton v-if="object.status" color="danger"
                                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->


                                        <div v-if="contacto" class="flex col-row gap-3"><!-- <-- cols-4 para cuatro botones o 3  -->
                                            <!-- <div class="col-span-1">
                                                                <BaseButton color="info" :icon="mdiPencil"
                                                                    label=" Modificar" class="w-full" />
                                                            </div>
                                                            <div class="col-span-1">
                                                                <BaseButton color="success" :icon="mdiPencil" 
                                                                    label=" Modificar" class="w-full" />
                                                            </div> -->
                                            <div>
                                                <BaseButton color="warning" :icon="mdiPencil" @click="(actualizarContacto(contacto)), (action = 'edit_apoderado')" label=" Modificar" class="text-sm" />
                                            </div>
                                            <!-- <div>
                                                <BaseButton v-if="object.status" color="danger" @click="initModal('desactivar')" label="Deshabilitar" class="text-sm" />
                                                <BaseButton v-else color="success" :icon="mdiCheckCircle" @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                            </div> -->
                                            <!-- Establecer contacto por defecto -->
                                            <!-- <div class="col-span-1">
                                                                <BaseButton v-if="object.status" color="danger"
                                                                    @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                                <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                                    @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                            </div> -->
                                        </div>

                                    </div>

                                </div>
                            </div>




                        </div>

                    </template>
                    <!-- Editar apoderado -->
                    <template v-else-if="action == 'edit_apoderado' && canWrite">
                        <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar apoderado de {{ object.person.apellidos + ' ' + object.person.nombres }}</h3>
                            <form @submit.prevent="submitApoderado">
                                <FormField label="Apellidos y Nombres">
                                    <FormControl v-model="formApoderado.apellidos" type="text" required />
                                    <FormControl v-model="formApoderado.nombres" type="text" required />
                                    <FormControl v-model="formApoderado.sexo" type="select" :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Parentesco / Documento">
                                    <FormControl v-model="formApoderado.id_parentesco" type="select" required :options="parentescos" placeholder="Parentesco" />
                                    <FormControl v-model="formApoderado.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="formApoderado.num_doc" type="text" required />
                                    <FormControl v-model="formApoderado.type" type="select" placeholder="Tipo de apoderado" :options="typeContacts" />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="formApoderado.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="formApoderado.email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="formApoderado.domicilio" type="text" placeholder="Dirección" />
                                    <FormControl v-model="formApoderado.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="formApoderado.referencia" type="text" placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="formApoderado.fecha_nacimiento" type="date" />
                                    <FormControl v-model="formApoderado.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de apoderado -->

                                <FormField label="Información laboral" help="">
                                    <FormControl v-model="formApoderado.ocupation" type="text" labelinput="Profesión o a qué se dedica" />
                                    <FormControl v-model="formApoderado.trabajo" type="text" labelinput="Centro laboral" />
                                    <FormControl v-model="formApoderado.horario_laboral" type="text" labelinput="Horario de trabajo" />

                                </FormField>
                                <FormField label="Información de contacto laboral">
                                    <FormControl v-model="formApoderado.telefono_trabajo" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular_trabajo" type="tel" placeholder="Celular" />
                                    <!-- <FormControl v-model="formApoderado.email_trabajo" type="email" :icon="mdiMail" placeholder="Email"/> -->
                                </FormField>

                                <!-- <FormField label="Restablecer datos de Login / Pensión" :isoneintwo="true">
                                            <FormControl v-model="form.change_login" type="yesno" labelinput="Cambiar email y password por defecto?" :tooltipcontent="'Por defecto el usuario es DOCUMENTO'+confGlobal.value.USER_EMAIL_DEFAULT_SUFIJO+' y el password es el DOCUMENTO'"/>
                                            <FormControl v-model="form.pension_preferencial" type="number" labelinput="Pensión preferencial" :tooltipcontent="'Ingresar un monto si tiene pensión preferencial'"/>
                                            <FormControl v-model="form.becado" type="yesno" labelinput="Becado?" :tooltipcontent="'No se genera órdenes de pago'"/>
                                        </FormField> -->
                                <FormField label="Nota">
                                    <FormControl v-model="formApoderado.note" type="textarea" labelinput="Otra información" />
                                </FormField>
                                <div class="flex items-center justify-end mt-4">
                                    <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                    <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>

                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear apoderado -->
                    <template v-else-if="action == 'create_apoderado' && canWrite">
                        <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Agregar apoderado</h3>
                            <span v-if="existeContacto" class="font-semibold text-red-600 leading-tight">Ya existe una persona con el mismo Documento, se agregará esta persona como contacto!</span>
                            <form @submit.prevent="submitApoderado">
                                <FormField label="Parentesco / Documento" required>
                                    <FormControl v-model="formApoderado.id_parentesco" required type="select" :options="parentescos" placeholder="Parentesco" />
                                    <FormControl v-model="formApoderado.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="formApoderado.num_doc" name="num_doc" type="text" required @change="getContactForDoc(formApoderado.num_doc)" />
                                    <FormControl v-model="formApoderado.type" type="select" placeholder="Tipo de apoderado" :options="typeContacts" />
                                </FormField>
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="formApoderado.apellidos" name="apellidos" type="text" required placeholder="Apellidos" />
                                    <FormControl v-model="formApoderado.nombres" name="nombres" type="text" required placeholder="Nombres" />
                                    <FormControl v-model="formApoderado.sexo" name="genero" type="select" :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Información de contacto">
                                    <FormControl v-model="formApoderado.telefono" name="telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="formApoderado.celular" name="celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="formApoderado.email" name="email" type="email" :icon="mdiMail" placeholder="Email" />
                                </FormField>

                                <FormField label="Domicilio">
                                    <FormControl v-model="formApoderado.domicilio" name="direccion" type="text" placeholder="Dirección" />
                                    <FormControl v-model="formApoderado.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="formApoderado.referencia" name="ref_domicilio" type="text" placeholder="Referencia de domicilio" />
                                </FormField>

                                <FormField label="Datos de nacimiento">
                                    <FormControl v-model="formApoderado.fecha_nacimiento" type="date" />
                                    <FormControl v-model="formApoderado.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>

                                <!-- Datos de estudiante -->
                                <!-- <FormField label="Colegio de procedencia">
                                            <FormControl v-model="formApoderado.id_parentesco" type="select" :options="parentescos" placeholder="Parentesco" />
                                            <FormControl v-model="formApoderado.id_distrito_colegio" type="select" :options="distritos" placeholder="Distrito" />
                                        </FormField> -->
                                <!-- <FormField label="Religión / Exonerado" help="Detalle si congrega una religión y si desea ser exonerado del curso de religión">
                                            <FormControl v-model="form.id_religion" type="select" :options="religions" placeholder="Escoja una Religión" />
                                            <FormControl v-model="form.exonerado_religion" type="yesno" placeholder="exonerado" />
                                        </FormField>
                                        <FormField label="Datos de salud del estudiante" help="Detalle si presenta alguna alergia o enfermedad a tomar en cuenta y si es apto para realizar ejercicios">
                                            <FormControl v-model="form.alergia" type="text" labelinput="Alérgico a algun medicamento" />
                                            <FormControl v-model="form.enfermedad" type="text"  labelinput="Alguna enfermedad a considerar"/>
                                            <FormControl v-model="form.apto_edu_fisica" type="yesno" placeholder="es apto" labelinput="Apto para educación física" />
                                            <FormControl v-model="form.tamisaje_hemoglobina" type="select" :options="optionsTamizaje" placeholder="Escoja una opción" labelinput="Tamizaje de hemoglobina" />
                                        </FormField> -->



                                <div class="flex items-center justify-end mt-4">



                                    <Link :href="route('student-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>
                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                </template>
                <!-- <template v-else-if="(tab == 1)">
                            <div >
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Informe de progreso</h3>
                            Informe de progreso
                            </div>
                        </template>
                        <template v-else-if="(tab == 2)">
                            <div >
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Portafolio</h3>
                            Portafolio
                            </div>
                        </template>
                        <template v-else-if="(tab == 3)">
                            <div >
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Anecdotario</h3>
                                Anecdotario
                            </div>
                        </template>
                        <template v-else-if="(tab == 4)">
                            <div>
                                <h3 class="md:text-2xl text-xl my-4 font-bold">Carpeta de recuperación</h3>
                                Carpeta de recuperación
                            </div>
                        </template> -->

                <!-- Información académica -->
                <template v-else-if="(tab == 2)">
                    <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">
                        <div class="mb-4">
                            <h3>Año de consulta
                                <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="anioSearch" @change="changeAnioConsulta()" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
                            </h3>
                            <small>Nivel y aula actual {{ confGlobal.value.CICLO_ANIO_ESCOLAR }}: {{ object.level ? object.level.label_short : '' }} {{ object.classroom ? object.classroom.label : '' }}</small>
                        </div>
                        <div class="grid grid-cols-1">
                            <div class="flex flex-col gap-3">
                                <!-- LRR justify-between para dos áreas con el mimos ancho o no se -->
                                <!--:date="client.created"-->
                                <!--{{ object.ciclos }} object.person.id_distrito_domicilio ? distritos.find(item => item.id === object.person.id_distrito_domicilio ).label : ''-->

                                <!-- Cursos -->
                                <div class="tab-card tab-light">
                                    <input class="tab-input" id="tab-alumnos" type="radio" name="tabs2">
                                    <label class="tab-label ico-radio" for="tab-alumnos">
                                        <div>
                                            <span>
                                                <BaseIcon :path="mdiFileDocumentMultipleOutline" :size="24" class="mr-3 " />
                                                Libreta / Cursos
                                            </span>
                                        </div>
                                    </label>
                                    <div class="tab-content">
                                        <div class="grid gap-4 lg:max-h-max max-h-[600px] overflow-y-auto">
                                            <CardBox has-table class="pt-3 px-3">
                                                <BaseButtons type="justify-start" no-wrap><!--lg:justify-end-->
                                                    <BaseButton color="info" :icon="mdiPrinter" label="Libreta" small :href="'/calification/libreta' + '?id=' + object.id + '&anioSearch=' + anioSearch" target="_blank" />
                                                </BaseButtons>
                                            </CardBox>

                                            <!-- EAP -->
                                            <div v-if="haveEAP">
                                                <div class="font-bold text-lg mb-2">Simulacro tipo examen de admisión</div>
                                                <li>Para imprimir el diploma lo debe hacer en la sección Aula -> Puntajes
                                                    EAP. Debe filtrar por Bimestre y grado.</li>
                                                <li>Para cambiar el puntaje lo puede realizar en la sección Aula -> ingresa
                                                    al aula del estudiante y realice el cambio en puntajes de simulacro.
                                                </li>
                                                <div class="grid">
                                                    <div v-if="arrayAdmisionPuntaje.length" v-for="client in arrayAdmisionPuntaje" :key="client.id" class="grid grid-cols-4 bg-gray-100 py-2 px-4 mb-3 rounded-lg">

                                                        <div class="col-span-2 md:col-span-3 inline-flex items-center pt-2">
                                                            <!-- <BaseIcon v-if="client.type == 'PDF'" :path="mdiPaperclip" :size="32"
                                                                            class="text-red-600 mr-2" />
                                                                        <BaseIcon v-else :path="mdiPaperclip" :size="32" class="text-lime-600 mr-2" /> -->
                                                            <span>
                                                                {{ client.ref_ciclo }}
                                                            </span>
                                                            <span class="ml-2">

                                                                {{ client.label_eap }}
                                                            </span>
                                                            <span class="ml-2">

                                                                {{ client.puntaje }}
                                                            </span>
                                                            <span class="ml-2">
                                                                <small v-if="client.resultado == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                                                    <span>Ingresó</span>
                                                                </small>
                                                                <small v-else-if="client.resultado == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                                                    <span>Ausente</span>
                                                                </small>
                                                                <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                                                    <span>No ingresó</span>
                                                                </small>
                                                            </span>
                                                        </div>
                                                        <!-- A futuro si es que se guarda el registro de ranking -->
                                                        <BaseButtons v-if="confGlobal.value.INICIO_STUDENT_SHOW_PRINT_DIPLOMA == '1'" type="justify-start lg:justify-end" no-wrap>

                                                            <BaseButton color="info" :icon="mdiPrinter" small :href="'/admisionpuntaje/diploma' + '?id=' + client.id" target="_blank" />


                                                        </BaseButtons>
                                                    </div>
                                                    <div v-else class="col-span-2 md:col-span-1 bg-gray-100 p-4 rounded-lg">
                                                        <span> No se registraron punajes de examen tipo admisión …</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="px-3">
                                                <div>
                                                    <p class="font-semibold text-base">No tiene un EAP asignado.</p>
                                                    <li class="text-sm">Para asignar EAP lo puede hacer en el aula -> Listado de alumnos.</li>
                                                </div>
                                            </div>
                                            <div v-if="cursos.length" class="overflow-x-auto">
                                                <div class="mb-3 px-3">
                                                    <p class="font-semibold text-base">Cursos del nivel actual o de consulta anual</p>
                                                    <li class="text-sm">Si es exonerado de religión en la libreta no se mostrará la nota</li>
                                                </div>
                                                <table class="w-full table-auto table-basic">
                                                    <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Curso</th>
                                                            <th>Nivel</th>
                                                            <th>Descripción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="cursos.length" v-for="(client, index) in cursos" :key="client.id" class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                                            <td>
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td>{{ client.label }} {{
                                                                client.nombres
                                                            }}</td>
                                                            <td>{{ client.label_level
                                                            }}</td>
                                                            <td>{{ client.description
                                                            }}</td>

                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- Calificaciones -->
                                <div class="tab-card tab-light">
                                    <input class="tab-input" id="tab-single-two" type="radio" name="tabs2">
                                    <label class="tab-label ico-radio" for="tab-single-two">
                                        <div>
                                            <span>
                                                <BaseIcon :path="mdiCheckDecagram" :size="24" class="mr-3 " />
                                                Calificaciones
                                            </span>
                                        </div>

                                    </label>
                                    <div class="tab-content">
                                        <div class="tab-interno">
                                            <button @click="(tabCalif = 0), listarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B1')" class="tab-interno-btn" :class="[tabCalif == 0 ? 'active' : 'inactivo']">
                                                Primer bimestre
                                            </button>
                                            <button @click="(tabCalif = 1), listarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B2')" class="tab-interno-btn" :class="[tabCalif == 1 ? 'active' : 'inactivo']">
                                                Segundo bimestre
                                            </button>
                                            <button @click="(tabCalif = 2), listarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B3')" class="tab-interno-btn" :class="[tabCalif == 2 ? 'active' : 'inactivo']">
                                                Tercer bimestre
                                            </button>
                                            <button @click="(tabCalif = 3), listarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + 'B4')" class="tab-interno-btn" :class="[tabCalif == 3 ? 'active' : 'inactivo']">
                                                Cuarto bimestre
                                            </button>
                                        </div>
                                        <!-- Tablas de Calificaciones por Bimestre -->
                                        <template v-for="(bim, idx) in [
                                            { id: 'B1', close: closeB1, p2: existParcial2B1 },
                                            { id: 'B2', close: closeB2, p2: existParcial2B2 },
                                            { id: 'B3', close: closeB3, p2: existParcial2B3 },
                                            { id: 'B4', close: closeB4, p2: existParcial2B4 }
                                        ]" :key="bim.id">
                                            <div v-if="tabCalif == idx">
                                                <div v-if="!canWrite && !isBimestrePublished(bim.id)" class="p-8 text-center bg-slate-50 border border-slate-200 rounded-2xl my-3 space-y-2">
                                                    <BaseIcon :path="mdiInformationOutline" :size="32" class="mx-auto text-amber-500" />
                                                    <h5 class="text-sm font-bold text-slate-800">Calificaciones aún no publicadas</h5>
                                                    <p class="text-xs text-slate-500 max-w-md mx-auto">
                                                        Las calificaciones de este periodo bimestral todavía no han sido publicadas para estudiantes y apoderados.
                                                    </p>
                                                </div>
                                                <template v-else>
                                                    <div v-if="arrayCalifications && !arrayCalifications.length">
                                                        <div class="w-full flex justify-start">
                                                            <template v-if="canWrite">
                                                                <div class="flex flex-col justify-start lg:flex-row p-3 lg:items-center gap-3">
                                                                    <div class="inline-block">
                                                                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Iniciar calificaciones" @click.once="iniciarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + bim.id)" />
                                                                    </div>
                                                                    <div>
                                                                        <BaseIcon :path="mdiInformationOutline" size="15" class="mr-1" />
                                                                        <span>Al iniciar las calificaciones todas se guardan inicialmente con 8.</span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <div v-else class="p-4">
                                                                <BaseIcon :path="mdiInformationOutline" size="15" /> No se han
                                                                iniciado calificaciones de este bimestre.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="canWrite && arrayCalifications.length" class="p-3 grid gap-3">
                                                            <div>
                                                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Añadir calificaciones faltantes" @click.once="iniciarCalification((anioSearch ? anioSearch : confGlobal.value.CICLO_ANIO_ESCOLAR) + bim.id)" />
                                                            </div>
                                                            <p>
                                                                * Puede pasar a la siguiente fila de la misma columna presionando
                                                                TAB o ENTER, presione CTRL para pasar a la siguiente columna de la misma fila. Todos los campos deben contener un valor número para
                                                                que el promedio sea válido.
                                                            </p>
                                                        </div>

                                                        <TableResponsive :headers="[
                                                            { key: 'index', label: '#', style: 'width: 30px; min-width: 30px;' },
                                                            { key: 'curso', label: 'Curso', standout: true },
                                                            { key: 'criterio1', label: trans?.criterio1 ? trans.criterio1 : 'Criterio 1', title: trans?.criterio1 ? trans.criterio1 : 'Criterio 1', class: 'text-center', condition: canWrite ? !!trans?.criterio1 : (isCriteriaPublished('criterio1') && !!trans?.criterio1), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'criterio2', label: trans?.criterio2 ? trans.criterio2 : 'Criterio 2', title: trans?.criterio2 ? trans.criterio2 : 'Criterio 2', class: 'text-center', condition: canWrite ? !!trans?.criterio2 : (isCriteriaPublished('criterio2') && !!trans?.criterio2), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'criterio3', label: trans?.criterio3 ? trans.criterio3 : 'Criterio 3', title: trans?.criterio3 ? trans.criterio3 : 'Criterio 3', class: 'text-center', condition: canWrite ? !!trans?.criterio3 : (isCriteriaPublished('criterio3') && !!trans?.criterio3), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'criterio4', label: trans?.criterio4 ? trans.criterio4 : 'Criterio 4', title: trans?.criterio4 ? trans.criterio4 : 'Criterio 4', class: 'text-center', condition: canWrite ? !!trans?.criterio4 : (isCriteriaPublished('criterio4') && !!trans?.criterio4), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'criterio5', label: trans?.criterio5 ? trans.criterio5 : 'Criterio 5', title: trans?.criterio5 ? trans.criterio5 : 'Criterio 5', class: 'text-center', condition: canWrite ? !!trans?.criterio5 : (isCriteriaPublished('criterio5') && !!trans?.criterio5), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'criterio6', label: trans?.criterio6 ? trans.criterio6 : 'Criterio 6', title: trans?.criterio6 ? trans.criterio6 : 'Criterio 6', class: 'text-center', condition: canWrite ? !!trans?.criterio6 : (isCriteriaPublished('criterio6') && !!trans?.criterio6), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'examen_parcial', label: 'Ex. parcial', title: 'Examen parcial', class: 'text-center', condition: canWrite || isCriteriaPublished('examen_parcial'), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'examen_parcial2', label: 'Ex. parcial2', title: 'Examen parcial2', class: 'text-center', condition: bim.p2 && (canWrite || isCriteriaPublished('examen_parcial2')), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'examen_final', label: 'Ex. final', title: 'Examen final', class: 'text-center', condition: canWrite || isCriteriaPublished('examen_final'), rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'promedio', label: 'Promedio', title: 'Promedio', class: 'text-center font-bold bg-blue-50 text-blue-900 border-l border-r border-blue-100', cellClass: 'bg-blue-50/30 border-l border-r border-blue-100 lg:bg-blue-50/30', rotate: true, style: 'width: 70px; min-width: 70px;' },
                                                            { key: 'actions', label: '', title: 'Actions', class: 'text-center', condition: canWrite && !bim.close },
                                                            { key: 'log', label: 'Log', title: 'Log', condition: canWrite }
                                                        ]" :items="arrayCalifications">
                                                        <template #cell-index="{ item: cal, index }">
                                                            <span :set="indexcol = 0">{{ index + 1 }}</span>
                                                            <input type="hidden" :set="numval = 0">
                                                            <input type="hidden" :set="sumval = 0">
                                                        </template>

                                                        <template #cell-curso="{ item: cal }">
                                                            <span class="bg-gray-100 lg:bg-transparent" :set="indexcol++">
                                                                {{ cal.label_course }} - {{ cal.ref_level }}
                                                            </span>
                                                        </template>

                                                        <template #cell-criterio1="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + 1">
                                                            <span v-if="!canWrite || bim.close">{{ cal.criterio1 }}</span>
                                                            <input v-else v-model="cal.criterio1" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio1) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio1 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio1)">
                                                            <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio1 || 0)">
                                                        </template>

                                                        <template #cell-criterio2="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + 1">
                                                            <span v-if="!canWrite || bim.close">{{ cal.criterio2 }}</span>
                                                            <input v-else v-model="cal.criterio2" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio2) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio2 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio2)">
                                                            <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio2 || 0)">
                                                        </template>

                                                        <template #cell-criterio3="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + 1">
                                                            <span v-if="!canWrite || bim.close">{{ cal.criterio3 }}</span>
                                                            <input v-else v-model="cal.criterio3" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio3) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio3 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio3)">
                                                            <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio3 || 0)">
                                                        </template>

                                                        <template #cell-criterio4="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + 1">
                                                            <span v-if="!canWrite || bim.close">{{ cal.criterio4 }}</span>
                                                            <input v-else v-model="cal.criterio4" @change="alertMinMax($event.target)" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio4) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio4 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio4)">
                                                            <input type="hidden" :set="sumval = sumval + parseInt(cal.criterio4 || 0)">
                                                        </template>

                                                        <template #cell-criterio5="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_CRITERIO5_PESO ?? 1)">
                                                            <input type="hidden" :set="cal.criterio5_peso = (confGlobal.value.CALIFICATION_CRITERIO5_PESO ?? 1)">
                                                            <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio5_peso">{{ cal.criterio5 }}</span>
                                                            <input v-else v-model="cal.criterio5" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio5_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio5) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio5 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio5)">
                                                            <input type="hidden" :set="sumval = sumval + parseFloat((cal.criterio5 || 0) * cal.criterio5_peso)">
                                                            <input type="hidden" v-model="cal.criterio5_peso">
                                                        </template>

                                                        <template #cell-criterio6="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_CRITERIO6_PESO ?? 1)">
                                                            <input type="hidden" :set="cal.criterio6_peso = (confGlobal.value.CALIFICATION_CRITERIO6_PESO ?? 1)">
                                                            <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio6_peso">{{ cal.criterio6 }}</span>
                                                            <input v-else v-model="cal.criterio6" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.criterio6_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.criterio6) ? 'bg-red-600 border-red-600 text-white' : (cal.criterio6 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.criterio6)">
                                                            <input type="hidden" :set="sumval = sumval + parseFloat((cal.criterio6 || 0) * cal.criterio6_peso)">
                                                            <input type="hidden" v-model="cal.criterio6_peso">
                                                        </template>

                                                        <template #cell-examen_parcial="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_PARCIAL_PESO ?? 1)">
                                                            <input type="hidden" :set="cal.examen_parcial_peso = (confGlobal.value.CALIFICATION_EXAMEN_PARCIAL_PESO ?? 1)">
                                                            <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial_peso">{{ cal.examen_parcial }}</span>
                                                            <input v-else v-model="cal.examen_parcial" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_parcial) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_parcial < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_parcial)">
                                                            <input type="hidden" :set="sumval = sumval + parseFloat((cal.examen_parcial || 0) * cal.examen_parcial_peso)">
                                                            <input type="hidden" v-model="cal.examen_parcial_peso">
                                                        </template>

                                                        <template #cell-examen_parcial2="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_PARCIAL2_PESO ?? 1)">
                                                            <input type="hidden" :set="cal.examen_parcial2_peso = (confGlobal.value.CALIFICATION_EXAMEN_PARCIAL2_PESO ?? 1)">
                                                            <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial2_peso">{{ cal.examen_parcial2 }}</span>
                                                            <input v-else v-model="cal.examen_parcial2" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_parcial2_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_parcial2) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_parcial2 < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol++) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_parcial2)">
                                                            <input type="hidden" :set="sumval = sumval + parseFloat((cal.examen_parcial2 || 0) * cal.examen_parcial2_peso)">
                                                            <input type="hidden" v-model="cal.examen_parcial2_peso">
                                                        </template>

                                                        <template #cell-examen_final="{ item: cal, index }">
                                                            <input type="hidden" :set="numval = numval + parseFloat(confGlobal.value.CALIFICATION_EXAMEN_FINAL_PESO ?? 1)">
                                                            <input type="hidden" :set="cal.examen_final_peso = (confGlobal.value.CALIFICATION_EXAMEN_FINAL_PESO ?? 1)">
                                                            <span v-if="!canWrite || bim.close" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_final_peso">{{ cal.examen_final }}</span>
                                                            <input v-else v-model="cal.examen_final" @change="alertMinMax($event.target)" :title="'Num. Val.: ' + numval + ', peso: ' + cal.examen_final_peso" class="inline-block input-small text-center w-20 lg:w-full focusNext" :class="[isNotaInvalida(cal.examen_final) ? 'bg-red-600 border-red-600 text-white' : (cal.examen_final < 11 ? 'text-red-600' : '')]" @focus="$event.target.select()" :tabindex="((indexcol) * 100) + index" :disabled="hasInvalidGrades && !isNotaInvalida(cal.examen_final)">
                                                            <input type="hidden" :set="sumval = sumval + parseFloat((cal.examen_final || 0) * cal.examen_final_peso)">
                                                            <input type="hidden" v-model="cal.examen_final_peso">
                                                        </template>

                                                        <template #cell-promedio="{ item: cal }">
                                                            <div class="text-center items-center font-bold text-base" :class="(cal.promedio < 11 ? 'text-red-600' : 'text-blue-900')" :set="cal.promedio_text = number2nota(cal.promedio = Math.round(promedio_decimal = parseFloat((sumval) / numval).toFixed(2)))" :title="sumval + '/' + numval + ' = ' + promedio_decimal + ' = ' + cal.promedio_text">
                                                                <span v-if="!canWrite || bim.close">{{ cal.promedio }}</span>
                                                                <input v-else v-model="cal.promedio" class="inline-block input-small text-center w-20 lg:w-full font-bold text-base" :class="(cal.promedio < 11 ? 'text-red-600' : 'text-blue-900')" :disabled="hasInvalidGrades && !isNotaInvalida(cal.promedio)">
                                                                <input type="hidden" v-model="cal.promedio_text">
                                                            </div>
                                                        </template>

                                                        <template #cell-actions="{ item: cal }">
                                                            <BaseButtons type="justify-center space-x-3 lg:justify-end" no-wrap>
                                                                <BaseButton :name="'buttonssave' + bim.id" color="info" :icon="mdiContentSave" small @click="updateCalification(cal.id, 'actualizar', cal)" :disabled="hasInvalidGrades" />
                                                            </BaseButtons>
                                                        </template>

                                                        <template #cell-log="{ item: cal }">
                                                            <div @click="showLog = !showLog">
                                                                <BaseIcon :path="mdiInformationOutline" title="Modificado por" size="15" />
                                                                <span class="text-xs" v-if="showLog">Modif. {{ cal.nombre_usuario }} {{ cal.updated_at ? formatDateTime(cal.updated_at) : '' }}</span>
                                                            </div>
                                                        </template>
                                                    </TableResponsive>
                                                    <div class="py-4 w-full flex justify-center" v-if="arrayCalifications.length && canWrite && !bim.close">
                                                        <BaseButton :icon="mdiContentSave" color="info" label="Guardar todo" icon-size="20" small @click="updateArrayCalifications(bim.id)" :disabled="hasInvalidGrades" />
                                                    </div>
                                                </div>
                                                </template>
                                            </div>
                                        </template>

                                        <div class="p-3" v-if="tabCalif == -1">
                                            Click al bimestre para mostrar el listado ⤴
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </template>
                <!-- Agenda -->
                <template v-else-if="(tab == 3)">
                    <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">

                        <!-- <div class="container">
                                        <VueCal
                                        :time="false"
                                        locale="es"
                                        :disable-views="['years', 'year']"
                                        :events="events"
                                        class="vuecal--green-theme"
                                        active-view="month"
                                        hide-weekends 
                                        />
                                    </div> -->

                        <!-- Registro Diario -->
                        <li>(A): Asistencia</li>
                        <li>(F): Falta</li>
                        <li>(T): Tardanza</li>

                        <!-- Documentación: https://antoniandre.github.io/vue-cal/?ref=madewithvuejs.com -->
                        <!-- Ejemplo: https://codepen.io/antoniandre/pen/jJbygw?editors=1010 -->
                        <!-- If the container has no height, set a height on vue-cal -->
                        <!-- vuecal--green-theme o vuecal--blue-theme -->
                        <!-- active-view="month" por defecto se ve por semana en la confiuración anterior -->

                        <!-- https://antoniandre.github.io/vue-cal/#ex--calendar-themes -->
                        <!-- vuecal--rounded-theme -->
                        <!-- hide-view-selector  es para ocultar la sección de la vista tipo mes o semana-->
                        <!-- xsmall  lo establece en formato pequeño y el nombre de días lo pone en abreviado-->

                        <!-- Otros estilos -->
                        <!-- https://antoniandre.github.io/vue-cal/#css-notes -->

                        <!-- <div class="block h-full w-full">
                                        <VueCal
                                        xsmall
                                        :time="false"
                                        locale="es"
                                        hide-view-selector
                                        :disable-views="['years', 'year']"
                                        :events="events"
                                        class="vuecal--date-picker vuecal--green-theme"
                                        active-view="week"
                                        hide-weekends
                                        
                                        />
                                    </div> -->

                        <div class="block h-full w-full">
                            <VueCal :transitions="false" small :time="false" locale="es" hide-view-selector :disable-views="['years', 'year', 'day', 'month']" :events="events" class="cal-rose" active-view="week" hide-weekends />
                            <!-- xsmall abreviatura de los títulos de días L, M, M -->
                            <!-- :on-event-click="onEventClick" -->
                        </div>


                    </div>
                </template>
                <!-- Informe Histórico -->
                <template v-else-if="(tab == 4)">
                    <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">
                        <h3>Informe histórico</h3>
                        <small>Nivel y aula actual {{ confGlobal.value.CICLO_ANIO_ESCOLAR }}: {{ object.level ? object.level.label_short : '' }} {{ object.classroom ? object.classroom.label : '' }}</small>
                        <div class="grid grid-cols-1 gap-6 mb-6">
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="stories.length" class="mb-6" has-table>
                                    <div class="mt-6">



                                        <table class="w-full table-auto table-basic">
                                            <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600 text-center">
                                                <tr>
                                                    <th scope="col" class="">#</th>
                                                    <th scope="col" class="">Año</th>
                                                    <th scope="col" class="">Nivel</th>
                                                    <th scope="col" class="">Fecha Matrícula</th>
                                                    <th scope="col" class="">Tipo</th>
                                                    <th scope="col" class="">Aula de estudio</th>
                                                    <th scope="col" class="">Aula de matrícula</th>
                                                    <th scope="col" class="">Aula Ugel</th>
                                                    <th scope="col" class="">Exonerado Religión</th>
                                                    <th scope="col" class="">Estado</th>
                                                    <th v-if="isSecre || isAdmin" scope="col" class=""></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="stories.length" v-for="(client, index) in stories" :key="client.id" class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700 ">
                                                    <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                                    </td>
                                                    <td class="whitespace-nowrap border-none text-center">{{ client.anio }}</td>
                                                    <td class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <FormControl v-model="client.id_level" type="select" :options="levels" placeholder="Escoja una opción" labelinput="Nivel/Grado de estudio" />
                                                        </div>
                                                        <div v-else>
                                                            {{ client.label_level }}
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap border-none text-center"> {{ client.fecha_matricula }} </td>
                                                    <td class="whitespace-nowrap border-none text-center"> {{ client.type ? 'Antiguo' : 'Nuevo' }} </td>
                                                    <td class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <FormControl v-model="client.id_classroom" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula de estudio" />
                                                        </div>
                                                        <div v-else>
                                                            {{ client.label_classroom }}
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <FormControl v-model="client.id_classroom_matricula" type="select" :options="classrooms" placeholder="Escoja una opción" labelinput="Aula matrícula" />
                                                        </div>
                                                        <div v-else>
                                                            {{ client.label_classroom_matricula }}
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <FormControl v-model="client.id_classroom_ugel" type="select" :options="teoricClassrooms" placeholder="Escoja una opción" labelinput="Aula Ugel" />
                                                        </div>
                                                        <div v-else>
                                                            {{ client.ref_classroom_ugel + ' ' + client.label_classroom_ugel }}
                                                        </div>
                                                    </td>
                                                    <td class="whitespace-nowrap border-none text-center"> {{ client.exonerado_religion ? 'Si' : 'No' }} </td>
                                                    <td class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <FormControl v-model="client.student_status" type="select" :options="[{'id': 1, 'label': 'Definitiva'}, {'id': 0, 'label': 'Trasladado'}]" placeholder="Escoja una opción" labelinput="Estado" />
                                                        </div>
                                                        <div v-else>
                                                            {{ client.student_status ? 'Definitiva' : 'Trasladado' }}
                                                        </div>
                                                    </td>
                                                    <td v-if="isSecre || isAdmin" class="whitespace-nowrap border-none text-center">
                                                        <div v-if="confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1">
                                                            <BaseButton color="warning" small label="Actualizar" @click="updateStory(client.id, client)" />
                                                        </div>
                                                    </td>

                                                </tr>
                                                <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                                    <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                            registros …</span></td>

                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </CardBox>

                            </div>
                        </div>
                    </div>
                </template>
                <!-- Documentos -->
                <template v-else-if="(tab == 5)">
                    <div class="grid grid-cols-1 bg-white shadow-lg border rounded-md p-4">
                        <div class="col-span-1">
                            <h3 class="mb-3">Documentos adjuntos</h3>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                                    PNG, con un <b>límite máximo</b> de {{
                                        confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                                </p>
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <!-- <div>
                                <BreezeLabel for="pos" value="Posición" />
                                <BreezeInput id="inputpos" type="number"
                                    class="mt-1 block" v-model="inputFilePos" />
                                </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_document_student" ref="fileDocument" type="file" @change="changeFile('file_document_student')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <div class="col-span-1 no-number mb-4">
                                    <label for="documentNotify" class="text-sm mb-1" data-title="Si el servicio de notificación está habilitada se enviará un mensaje al adminsitrador">Notificar al administrador </label>
                                    <input id="documentNotify" name="documentNotify" type="checkbox" class="" v-model="documentNotify">
                                </div>

                                <!-- <label>
                                    <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                                </label> -->

                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_document_student')" class="btn btn-blue px-8 lg:w-auto w-full" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_document_student" :originId="object.id" @reload="listarDocumentos()" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- Financiera -->
                <template v-else-if="(tab == 6)">
                    <div class="grid grid-cols-1 bg-white shadow-lg border rounded-md p-4">
                        <h2 class="mb-3">Record de pagos</h2>

                        <!-- <div v-if="message">{{ message }}</div> -->

                        <div v-if="canWrite" class="mb-3">
                            <div class="mb-3">
                                <ul class="text-sm">
                                    <li>Puede registrar otras ordenes de pago para que el administrador de finanzas valide los mismos, estos pueden ser pagos de vacacional, certificados, uniformes, libros, etc.</li>
                                    <li>La fecha de emisión es en la que se procesa el registro, la fecha de vencimiento puede ser la misma que la fecha de emisión o si es que tiene un plazo de pago puede ser posterior</li>
                                    <li>La etiqueta o referencia puede ser de la <b>lista sugerida</b> o puede escribir <b>otro motivo</b> que no esté en la lista</li>
                                    <li>Por seguridad sólo puede ingresar un registro a la vez, si desea ingresar otro de este mismo estudiante debe ir al listado y volver a ingresar a la ficha de este estudiante.</li>
                                </ul>
                            </div>
                            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                                <div class="col-span-1">
                                    <label for="fechaEmision" class="text-sm mb-1">Fecha emisión </label>
                                    <input id="fechaEmision" name="fechaEmision" type="date" class="w-full" v-model="fechaEmision" autocomplete="off">
                                </div>
                                <div class="col-span-1">
                                    <label for="fechaVencimiento" class="text-sm mb-1">Fecha Vencimiento </label>
                                    <input id="fechaVencimiento" name="fechaVencimiento" type="date" class="w-full" v-model="fechaVencimiento" autocomplete="off">
                                </div>


                                <div class="col-span-1">
                                    <!-- <label for="orderVariosLabel">Etiqueta/Referencia </label> 
                                        <input id="orderVariosLabel" name="orderVariosLabel" type="text" class="w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="orderVariosLabel" autocomplete="off">
                                         -->
                                    <label for="orderVariosLabel" class="text-sm mb-1">Etiqueta/Referencia </label>
                                    <input v-model="orderVariosLabel" type="search" class="w-full" placeholder="" list="list-ref-otros" id="orderVariosLabel" name="orderVariosLabel" autocomplete="off">
                                    <datalist id="list-ref-otros" name="list-ref-otros" class="mb-3 rounded-md">
                                        <option value="VACACIONAL">VACACIONAL</option>
                                        <option value="CIRCULO VERANO">CIRCULO VERANO</option>
                                        <option value="CERTIFICADO DE ESTUDIOS">CERTIFICADO DE ESTUDIOS</option>
                                        <option value="CONSTANCIA DE MATRICULA">CONSTANCIA DE MATRICULA</option>
                                        <option value="CONSTANCIA DE NO ADEUDO">CONSTANCIA DE NO ADEUDO</option>
                                        <option value="CONSTANCIA DE NOTAS">CONSTANCIA DE NOTAS</option>
                                        <option value="CONSTANCIA DE TERCIO SUPERIOR">CONSTANCIA DE TERCIO SUPERIOR</option>
                                        <option value="CONSTANCIA DE QUINTO SUPERIOR">CONSTANCIA DE QUINTO SUPERIOR</option>
                                        <option value="CONSTANCIA DE DECIMO SUPERIOR">CONSTANCIA DE DECIMO SUPERIOR</option>
                                    </datalist>
                                    <!-- <select id="list-ref-otros" name="list-ref-otros" class="w-full">
                                        <option value="VACACIONAL">VACACIONAL</option>
                                        <option value="CIRCULO VERANO">CIRCULO VERANO</option>
                                        <option value="CERTIFICADO DE ESTUDIOS">CERTIFICADO DE ESTUDIOS</option>
                                        <option value="CONSTANCIA DE MATRICULA">CONSTANCIA DE MATRICULA</option>
                                        <option value="CONSTANCIA DE NO ADEUDO">CONSTANCIA DE NO ADEUDO</option>
                                        <option value="CONSTANCIA DE NOTAS">CONSTANCIA DE NOTAS</option>
                                        <option value="CONSTANCIA DE TERCIO SUPERIOR">CONSTANCIA DE TERCIO SUPERIOR</option>
                                        <option value="CONSTANCIA DE QUINTO SUPERIOR">CONSTANCIA DE QUINTO SUPERIOR</option>
                                        <option value="CONSTANCIA DE DECIMO SUPERIOR">CONSTANCIA DE DECIMO SUPERIOR</option>
                                    </select> -->
                                </div>
                                <div class="col-span-1 no-number">
                                    <label for="orderVariosAmount" class="text-sm mb-1">Monto </label>
                                    <input id="orderVariosAmount" name="orderVariosAmount" type="number" class="w-full" v-model="orderVariosAmount" autocomplete="off">
                                </div>
                                <div class="col-span-1 no-number">
                                    <label for="orderVariosNotify" class="text-sm mb-1" title="Si el servicio de notificación está habilitada se enviará un mensaje al adminsitrador de finanzas">Notificar al administrador </label>
                                    <input id="orderVariosNotify" name="orderVariosNotify" type="checkbox" class="" v-model="orderVariosNotify">
                                </div>
                                <div class="col-span-1">
                                    <span v-if="errorOrderVarios" class="font-medium text-red-600">Debe ingresar los campos requeridos</span>
                                    <BaseButton v-else :icon="mdiPlusCircle" color="info" class="btn btn-blue px-8 lg:w-auto w-full" icon-size="20" small label="Registrar orden de pago" title="Por seguridad sólo se permite un click a la vez" @click.once="iniciarOrdenPagoVarios()" />
                                </div>
                            </div>
                        </div>
                        <hr class="my-4">
                        <!-- Lista -->
                        <div class="w-full overflow-x-auto relative">
                            <CardBox v-if="arrayPayes.length" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvanced modulo="PayementOrder" modulos="Pagos" :data="arrayPayes" :fields="arrayPayesCol" ruta="payementorder" @reload="listarPayes()" />
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>


                    </div>
                </template>
                <template v-else-if="(tab == 7)">
                    <div class="grid grids-col-1 bg-white shadow-lg border rounded-md p-4">
                        <div class="block h-full w-full">
                            <!-- Clase para convertir \n en <br> o salto de línea -->
                            <div v-html="object.log" class="pre-wrapped-text"></div>
                        </div>
                    </div>
                </template>
        </div>


    </BreezeAuthenticatedLayout>
</template>
<style scope>
  .pre-wrapped-text {
    white-space: pre-wrap;
  }
</style>
